{
  "CCPADontSellButton": "Do Not Sell Or Share My Personal Information",
  "ConfirmImHere": "Confirm I'm Here",
  "NewAddressAdding": "Unit can be entered in next step",
  "RemoveDeliveryAddressConfirmation": "Remove Delivery Address Confirmation",
  "about": "About",
  "aboutTheApp": "About the App",
  "above": "above",
  "accept": "Accept",
  "acceptAllCookies": "Accept All Cookies",
  "acceptEmailsAndSpecialOffers": "I want to receive special offers and other information from Burger King via email",
  "acceptGiftError": "Please try again later or contact {supportLink} or by calling +1-888-601-1616.",
  "acceptGiftSuccess": "You have received a {gift} from {fullName}. The gift has been added to your account and will appear along with other offers. Don’t forget to activate it.",
  "acceptGiftSuccessHeading": "You got a gift!",
  "acceptMarketingSMSCommPrefs": "I agree to receive recurring autodialed telemarketing text messages from Burger King at the telephone number provided above and understand that my consent is not a condition of purchase. Messages & data rates may apply.",
  "acceptOrDecline": "Accept or Decline This Order",
  "acceptOrder": "Accept Order",
  "acceptOrderModal": "Please have this order ready for {serviceMode} by {time} on {date}. You will not be able to decline an order after accepting it here.",
  "acceptPrivacyPolicyAndTerms": "I agree to the following: {privacyPolicyLink} and {termsOfServiceLink}",
  "acceptRollsCongrats": "Congrats!",
  "acceptRollsModalHeader": "You have received {numberOfRollsShared, plural, one {a} other {{numberOfRollsShared}}} RRROLL{numberOfRollsShared, plural, one {} other {S}}!",
  "acceptTermsAndPrivacyCommPrefs": "I have read and agree to the {bkRoyalPerksTextProgramLink}, the {privacyPolicyLink}, and {rewardsPolicyLink}.",
  "acceptTermsAndPrivacyIntro": "I agree to the following: {privacyPolicyLink}, {rewardsPolicyLink}, {termsOfServiceLink}",
  "acceptedCateringOrder": "Please have this order ready for {serviceMode} at {time}, {date}",
  "accessibility": "Accessibility",
  "accessibilityMode": "Accessibility Mode",
  "account": "Account",
  "accountDefault": "default",
  "accountDetails": "Account Details",
  "accountInfo": "Account Info",
  "accountRewardsPoints": "You have {points} available",
  "accountRewardsPointsExpiration": "{pointsToExpire} Crowns will expire \n {expirationDateTime}",
  "accountWithEmailAlreadyExists": "An account with the given email already exists.",
  "activate": "Activate",
  "activateOffer": "Activate Offer",
  "activated": "Activated",
  "activationFailed": "Activation failed!",
  "active": "Active",
  "add": "Add",
  "addCondiments": "Add Condiments",
  "addCreditCard": "Add a Credit Card",
  "addCreditCardVerification": "Add Credit Card Verification",
  "addCreditDebitCard": "Add Debit / Credit Card",
  "addExtras": "Add Extras",
  "addFavorite": "Add to Favorites",
  "addFromCheckout": "Add from checkout",
  "addGiftCard": "Add Gift Card",
  "addGiftCardError": "We were unable to create a digital Tim Card. Your payment method has not been charged. Please try again or {link}.",
  "addItemLabel": "Add one {itemName} to your cart?",
  "addItemToCart": "Add {name} to cart",
  "addItemToCartWithModifiers": "Add {name} with {modifiers} to cart",
  "addItems": "Add Items",
  "addItemsLowerCase": "Add items",
  "addMobileOrder": "Add to Mobile Order",
  "addNewCard": "Add New Debit or Credit Card",
  "addNewCreditCard": "Add a New Credit Card",
  "addNewPaymentMethod": "Add New Payment Method",
  "addNewPaymentMethodGiftCard": "Add a Gift Card",
  "addOffers": "Add Offers",
  "addOne": "Add one",
  "addOneItemToCart": "Add one {itemName} to your cart.",
  "addOneName": "Add one {name}",
  "addPayment": "Add Payment",
  "addPaymentMethod": "Add Payment Method",
  "addPaymentMethodOrReload": "Add Payment Method",
  "addPaymentMethodOrReload.th": "Add Reload Method",
  "addPhoneNumber": "Add Phone Number",
  "addPrepaidCard": "Add a BK Gift Card",
  "addQuantityAndItemToCart": "Add {quantity} {itemName} to cart",
  "addQuantityAndItemWithPrice": "Add {quantity} {itemName} to order for {price}",
  "addReloadMethod": "Add Reload Method",
  "addReward": "Add Reward",
  "addRewards": "Add Rewards",
  "addSomethingExtra": "Add something extra to complete your order",
  "addSpecificInstructions": "Add any specific delivery instructions here",
  "addTag": "Add Tag",
  "addTimCard": "Add Tim Card",
  "addToAppleWalletAlt": "Add to Apple Wallet",
  "addToCart": "Add",
  "addToCartCarousel": "Add to Cart",
  "addToCartError": "Unable to add {itemName} to cart. Please try again.",
  "addToCartMultipleSuccess": "{itemName} and {quantity} {quantity, plural, one {other} other {others}} added to cart",
  "addToCartSuccess": "{itemName} added to cart",
  "addToGooglePayAlt": "Add to Google Pay",
  "addToInRestaurantRedemptionCartSuccess": "{type} saved to redeem in restaurant.",
  "addToOrder": "Add to Order",
  "addToOrderHeader": "Add to Order",
  "added": "Added",
  "additionalAddressInformation": "Unit can be entered during checkout",
  "additionalInfoAdditives": "Additives",
  "additionalInfoIngredients": "Ingredients",
  "additionalInfoProducerDetails": "Producer Details",
  "additionalInfoTitle": "Additional item information",
  "additionalInstructions": "Additional instructions",
  "addons": "Add-Ons",
  "address": "Address",
  "addressError": "Oops! Address not recognized.",
  "addressFieldIsRequired": "Address field is required",
  "addressRequired": "Address (Required)",
  "addressRequiredError": "Address is a required field.",
  "adjustQuantityOfItem": "Adjust quantity of {itemName}",
  "adsPersonalization": "Interest-based Advertising",
  "adsPersonalizationInfo": "If enabled, we may share your contact information and device id with social media and other third-party platforms to help us deliver ads & offers that may interest you and others. You may opt out at any time, but please note that opting out may affect the relevance of the ads & offers that you may receive. To learn more, please see the {privacyPolicyLink}.",
  "afterDiscount": "After discount",
  "afterSevenPurchases": "After every seven purchases, you can collect your reward.",
  "afternoon": "Afternoon",
  "agreeToTermsOfService": "Agree to terms of service",
  "agreeToTermsOfServiceError": "You must agree to the privacy policy and terms of service before signing up.",
  "agreeToTheFollowing": "I agree to the following:",
  "agreeToTheTerms": "You must agree to the terms to enable SMS marketing communications.",
  "aliasAutoRenamed": "The selected alias was already used and has been renamed automatically.",
  "aliasError": "Please select a label (Home, Work, or Other).",
  "aliasLabelHome": "Home",
  "aliasLabelOther": "Other",
  "aliasLabelWork": "Work",
  "allMenu": "All Menu",
  "allRightsReserved": "All Rights Reserved.",
  "allSetCustomer": "All set, {firstName}!",
  "allergenInformation": "Allergen Information",
  "allergensDisclaimer": "This item {allergenContents}. Modifications are not represented in this list.",
  "allergensDisclaimerContains": "This item contains {allergens}. Modifications are not represented in this list.",
  "allergensDisclaimerContainsAndMayBeCookedOn": "This item contains {allergens} and may be cooked on same equipment as {maybeCookedOnAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerContainsAndMayContain": "This item contains {allergens} and may contain {maybeAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerContainsAndMayContainAndMayBeCooked": "This item contains {allergens}, may contain {maybeAllergens}, and may be cooked on same equipment as {maybeCookedOnAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerMayBeCookedOn": "This item may be cooked on same equipment as {maybeCookedOnAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerMayContain": "This item may contain {maybeAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerMayContainAndMayBeCookedOn": "This item may contain {maybeAllergens} and may be cooked on same equipment as {maybeCookedOnAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerUnknown": "This item may have allergens.",
  "allergensDownloadPDF": "Download Allergens",
  "allergensViewInBrowser": "Allergens View in Browser",
  "allergicTo": "I'm allergic to",
  "allowCameraAccess": "Allow BK app to access your camera",
  "allowCameraAccessWebText": "Enable your camera access to take photos. Use the camera icon in the browser bar or allow access through your browser settings.",
  "allowCameraAccessWebTitle": "Let BK.com use your camera",
  "allowLocationServices": "Allow location services",
  "allowLocationServicesToFind": "Allow location services to find",
  "alreadyHaveAPhysicalCard": "Already have a physical card?",
  "alreadyHaveAnAccount": "Already have an account?",
  "alreadyLinkedACard": "Already linked a card?",
  "amenities": "Amenities",
  "amount": "amount",
  "amountMore": "+{amountMore} more",
  "and": "and",
  "andConjunction": "{first} and {second}",
  "androidDownloadApp": "Android Download app button",
  "answer": "Answer",
  "anyQuestionsHeading": "Any questions?",
  "apartment": "Apartment",
  "appImage": "app-image",
  "appUpdateRecommended": "App Update Recommended",
  "appUpdateSubtext": "We recommend updating to the latest version of our app before proceeding with your order. Would you like to update now?",
  "appflowCompleted": "Update completed!",
  "appflowDownloading": "Downloading update.",
  "appflowError": "There was a problem downloading the update.",
  "appflowExtracting": "Extracting update.",
  "appflowProgress": "{progress} complete.",
  "applePay": "Apple Pay",
  "applePayPaymentNotAvailable": "We currently don’t accept Apple Pay on our websites. Please select or add a new payment method.",
  "apply": "Apply",
  "applyAReward": "Apply a reward",
  "applyPromoCode": "Apply Promo Code",
  "approve": "Approve",
  "approxMinutesAway": "(Approx. 5 min. away)",
  "approxMinutesAway.plk": "(Approx. 5 min. away)",
  "april": "April",
  "aptOrSuite": "Apt or Suite",
  "areDeliveryDetailsValid": "We are unable to confirm your phone number. Please confirm your phone number is correct or try a different one.",
  "asap": "ASAP",
  "asapOrder": "ASAP Order: {serviceMode}",
  "at": "at",
  "atARestaurant": "At a restaurant",
  "atRestaurantDetails": "Includes Take Out, Dine In, and more options",
  "attachToMyCode": "Attach to My Code",
  "attachedToMyCodeSuccess": "{type} attached to My Code.",
  "august": "August",
  "authContinueSubHeader": "Would you like to continue in App or on the website?",
  "authContinueWeb": "Continue on the website",
  "authEmailCheckYourEmail": "Check your email",
  "authEmailSentEmail": "We sent an email with login instructions to",
  "authEmailTimeToReceive": "It may take up to 3 minutes to receive the email.{separator}Click the link in the message to sign in.",
  "authEnterCode": "Enter Verification Code Below:",
  "authError": "An error occurred logging in",
  "authExpiredLink": "Your link may have expired or you are using a different browser. Request a new link by clicking the “{sendNewLinkText}” button below.",
  "authMissingLink": "Sorry, we can't find that link.",
  "authNewLink": "Send new link",
  "authPhoneSentSms": "We sent an sms with login instructions to",
  "authRegionErrorDetails": "Your account was registered for a different region. You need to create a new account for this region to be able to have the best experience using this application. You will be automatically signed-out now.",
  "authRegionErrorTitle": "Account region error",
  "authRetryError": "An error occurred. Press below to try again.",
  "authVerifyWithCode": "Verify with code",
  "autoReload": "Auto Reload",
  "autoReloadDefaultAmount": "Use {cardType} ending in {alias} to reload this amount:",
  "autoReloadDetails": "When you use auto-reload, you can automatically add money to your Tim Card when your balance is low.",
  "autoReloadPleaseSelectAFundingSource": "Please select a founding source",
  "autoReloadThreshold": "When my Tim Card balance is below:",
  "autoSignInSuccess": "Congratulations! Your account has been created.",
  "available": "Available",
  "availableAgainOn": "Available again on {date}",
  "availableCrowns": "Available Crowns",
  "availableForDelivery": "Available for Delivery",
  "availableForPickUp": "Available for Pick Up",
  "availablePoints": "Available Crowns",
  "back": "Back",
  "backToEarn": "Back to Earn",
  "backToMenu": "Back to menu",
  "backToOffers": "Back to offers",
  "backToSavedAddresses": "Back to Saved Addresses",
  "backToSummary": "Back to Summary",
  "backToTopics": "Back to topics",
  "backgroundImage": "background image",
  "backwardButton": "Backward Button",
  "badNetworkDialogBody": "To access all app features, please relocate to an area with stronger internet signal and retry.",
  "badNetworkDialogTitle": "You're currently offline",
  "bagEmpty": "Your bag is empty",
  "balanceNoCoverCostReloadToContinue": "Your current Tim Card balance won’t cover the cost of today’s order. Reload your Tim Card to continue.",
  "balanceReloadAmount": "Balance reload amount",
  "balanceTransfer": "Balance Transfer",
  "bankMyRewards": "Bank my crowns",
  "bankOrRedeemOnboardingDescription": "Choose to bank or redeem your Crowns. You can change your preference at any time!",
  "bankOrRedeemPoints": "Bank or Redeem Crowns",
  "bankYourPointsForLater": "You can change your Reward Level at any time.",
  "bankingPoints": "You're currently banking your Crowns",
  "beforeDiscount": "Before discount",
  "below": "below",
  "billingAddressIsSameAsDeliveryAddress": "Billing address is same as delivery address.",
  "billingCountryIsARequiredField": "Billing Country is a required field",
  "bk.payWithMyPrepaidCard": "Pay with BK Crown Card",
  "bk.pypestreamLoadingMessage": "One moment while we fire up support.",
  "bk.routes.privacyPolicy": "/privacy-policy",
  "bk.routes.terms": "/terms",
  "bk.routes.termsOfService": "/terms-of-service",
  "bkBadges": "BK Badges",
  "bkCareers": "BK Careers",
  "bkKingdom": "BK Kingdom",
  "bkRewards": "BK Rewards",
  "bkTermsUrl": "bk.com/terms",
  "bkWebsiteUrl": "bk.com",
  "bk_aboutBK": "About BK",
  "bk_allRightsReserved": "All Rights Reserved.",
  "bk_bkApp": "BK App",
  "bk_bkCares": "BK Cares",
  "bk_bkCrownsExpirationText": "BK Crowns never expire with an active account. Maintain your balance with an order at least once every 6 months.",
  "bk_bkMcLAMOREFoundation": "BK McLAMORE Foundation",
  "bk_bkTrademarkAndCopyright": "TM & Copyright 2021 Burger King Corporation.‌‌",
  "bk_bkcInfo": "BKC Info",
  "bk_bringItUpAtBKC": "Bring it @ BKC",
  "bk_giftOrCrownCard": "Gift Cards / Crown Card",
  "bk_logo_title": "Burger King",
  "bk_myBK": "My BK",
  "bk_myBKRewards": "My BK Rewards®",
  "bk_nutritionExplorer": "Nutrition Explorer",
  "bk_pointsBalance": "BK Crown Rewards:",
  "bonus": "Bonus",
  "bonusPoints": "{points} Bonus Crown{points, plural, one {} other {s}}",
  "bonusPointsIncentiveDescription": "You've earned {points} bonus Crowns completing this challenge!",
  "bonusPointsLabel": "Bonus Crown{points, plural, one {} other {s}}",
  "breakfastDayPartEnds": "Breakfast ends in {minutes, plural, one {# min} other {# mins}}",
  "breakfastDayPartHours": "Breakfast available until {endDateHours}",
  "breakfastDisclaimer": "Items available only for breakfast",
  "breakfastIsAvailableFromOpen": "Breakfast is available from open - {openTime}",
  "breakfastMenu": "Breakfast Menu",
  "brewingNewDownload": "Brewing new download",
  "browseOpportunities": "Browse Opportunities",
  "browseOurMenu": "Browse Our Menu",
  "browserSettings": "Browser Settings",
  "bsmConfirmationModalBody": "You will be taken to select a new service mode with a new restaurant or delivery address.",
  "bsmConfirmationModalHeading": "Are you sure you want to change your store?",
  "button": "button",
  "byDefault": "By Default",
  "cal": "Cal",
  "calculatingEta": "Calculating driver location",
  "calories": "Calories",
  "cameraUnavailable": "Camera is unavailable, review your settings",
  "campaignModal.answer.afternoon": "Afternoon",
  "campaignModal.answer.beef": "Beef",
  "campaignModal.answer.chicken": "Chicken",
  "campaignModal.answer.dessert": "Dessert",
  "campaignModal.answer.mediue": "Medium",
  "campaignModal.answer.morning": "Morning",
  "campaignModal.answer.night": "Night",
  "campaignModal.answer.small": "Small",
  "campaignModal.answer.snacks": "Snacks",
  "campaignModal.answer.tall": "Tall",
  "campaignModal.answer.veggie": "Veggie",
  "campaignModal.question.prefenceAditional": "What do you prefer?",
  "campaignModal.question.prefenceFood": "What is your preference? (multiple answers)",
  "campaignModal.question.prefenceSize": "Are you...?",
  "campaignModal.question.prefenceTime": "What time do you visit BK?",
  "canOnlyChooseOneOfferLine1": "You can only choose one offer from this group.",
  "canOnlyChooseOneOfferLine2": "After you pick one, this group won't be shown again.",
  "canada": "Canada",
  "cancel": "Cancel",
  "cancelCTA": "Cancel",
  "cancelCateringClearCart": "Your cart will be cleared if you decide to cancel your catering order",
  "cancelCateringOrder": "Cancel Catering Order",
  "cancelCurbsideOrder": "Cancel Order",
  "cancelCurbsideOrderText": "It looks like you already have a curbside order in progress.",
  "cancelCurbsideOrderTitle": "Cancel Curbside Order?",
  "cancelOrder": "Cancel Order",
  "cancellationPolicy": "No changes to the order can be made after placing your order.",
  "cancellationPolicyTitle": "Cancellation Policy",
  "cancelledOrderAction": "We're sorry, but it looks like your order has been cancelled and refunded. If you'd like to place your order again you can use the button below.",
  "cancelledOrderTitle": "Oh no! Your order was cancelled.",
  "cannotDeliveryTo": "We cannot currently deliver to",
  "cannotPlaceOrder": "Search for other restaurants nearby!",
  "cannotRemoveStoreFromFavorites": "In order to optimize your ordering experience to make it seamless, we need at least one favorite store.",
  "cannotRemoveStoreFromFavoritesHeader": "Cannot Remove Store From Favorites",
  "carbohydrates": "Carbohydrates",
  "carbs": "Carbs",
  "card": "CARD",
  "cardAddedNotification": "Card added!",
  "cardAlias": "Crown",
  "cardAlias.bk": "Gift",
  "cardAlias.plk": "Gift",
  "cardAlias.th": "Tim",
  "cardCurrenciesDontMatch": "The Tim Card you are trying to transfer is from a different region than your account. Only Tim Cards from your region can be transferred.",
  "cardDeactivationError": "We were unable to process your request. Please try again or {link} for assistance.",
  "cardExpiration": "Card Expiration Date",
  "cardNumber": "Card Number",
  "cardNumberIsRequired": "Card number is required",
  "cardNumberRequiredError": "Card number is a required field.",
  "cardSuccessfullyLinked": "The card {cardId} was successfully linked to your account. Your Crowns may take a few minutes to appear in your account.",
  "cardUpdatedNotification": "Card Updated!",
  "cardXHasABalanceOfY": "Card {cardNumber} has a balance of {balance}",
  "careers": "Careers",
  "careersHome": "Careers Home",
  "cart": "Cart",
  "cartCardLoadingMessage": "Firing Up Your Order...",
  "cartCardLoadingSuccess": "Success!",
  "cartCloseConfirmDialogHeading": "Your Order Is In Progress",
  "cartConfirmDialogBody": "We got this! Feel free to browse our app while we process your order.",
  "cartConfirmDialogConfirmLabel": "Okay, Check Recent Orders",
  "cartLoyaltyPoints": "You have {points} Crowns",
  "cartOfferRequirementsNotMetError": "The items in your cart do not meet the requirements of this offer",
  "cartPromotionOfferRequirementsNotMetError": "Your order does not meet the requirements of this promotion.",
  "cartTotal": "Cart total",
  "cartV2_incentiveFeedbackCartRequirement": "Need to purchase {incentiveType}",
  "cartV2_incentiveFeedbackPaymentMethod": "Offer only applies by paying with {targetValue}",
  "cartV2_incentiveFeedbackSubtotal": "Needs Minimum Purchase of ${targetValue}",
  "cash": "Cash",
  "cashApp": "Cash App",
  "cashAppDecline": "Could not link Cash App Pay. Please try again or choose a different payment method.",
  "cashAppError": "Something went wrong. Please try again or select a different payment method.",
  "cashAppPay": "Cash App Pay",
  "cashPayementsAcceptedAtTheCounter": "Cash payments will be completed at the counter",
  "catering": "Catering",
  "cateringChangeServiceModeDescription": "Exiting Catering service mode will result in your cart clearing. Continue changing service mode?",
  "cateringDashDelivery": "Catering - Delivery",
  "cateringDashPickUp": "Catering - Pickup",
  "cateringDelivery": "Catering Delivery",
  "cateringDeliveryUnavailable": "Catering Delivery - Unavailable",
  "cateringMinimumNotReached": "Sorry! Minimum order for catering is {min}.",
  "cateringOrder": "Catering Order",
  "cateringOrderPendingApproval": "Your order is currently pending. You'll receive an email once it's accepted.",
  "cateringOrderTimeout": "Catering order timeout",
  "cateringOrdersDisclaimer": "Catering orders take up to 24 hours to confirm. Your card will be charged.",
  "cateringPickUp": "Catering Pick Up",
  "cateringPickUpAt": "Catering Pick up at",
  "cateringPickup": "Catering Pick Up",
  "ccNumberIsNotValid": "Card Number is not valid",
  "celery": "celery",
  "challenge": "Challenge",
  "challengeCardPayment": "Challenge card payment",
  "challengeComplete": "Challenge Completed",
  "challengeCompleted": "Challenge Completed",
  "challengeOrderPayment": "Challenge order payment",
  "challengeStarted": "Challenge Started",
  "challenges": "Challenges",
  "change": "Change",
  "changeAddress": "Change Address",
  "changeAddressAriaLabel": "Link to change address location",
  "changeFundingSource": "{method} Funding Source",
  "changeLanguage": "Select Language and Region",
  "changePaymentMethod": "This store doesn’t accept this card type. Change your payment method and try again.",
  "changeRedemptionToInStore": "Are you sure you want to change to in-store redemption?",
  "changeRedemptionToInStoreConfirmLabel": "Change to in-store",
  "changeRedemptionToInStoreDescription": "Changing to in-store redemption will clear your cart. Are you sure you want to proceed?",
  "changeRedemptionToPickUp": "Are you sure you want to change to a mobile order?",
  "changeRedemptionToPickUpConfirmLabel": "Change to mobile order",
  "changeRedemptionToPickUpDescription": "Changing from in-store redemption to mobile order will clear your active perks. Are you sure you want to proceed?",
  "changeRegionConfirmation": "Please confirm your region to continue.",
  "changeRegionDisclaimer": "Please note you will need to select your restaurant again.",
  "changeRegionOnOrder": "We need a little more information, please confirm your region to continue ordering",
  "changeRestaurantDialogBody": "Changing your restaurant may result in differences in prices or item availability.",
  "changeRestaurantDialogConfirmButtonLabel": "Change Restaurant",
  "changeRestaurantDialogHeading": "Change Restaurant?",
  "changeServiceMode": "Change Service Mode",
  "changeStoreAriaLabel": "Link to change store location",
  "changeStoreItemDisclaimer": "Changing stores may change prices or item availability.",
  "changeStoreMessage": "Changing your store may result in differences in prices or item availability. Continue changing stores?",
  "changeStoreMessagePromptDisclaimer": "Changing your store may result in differences in prices and item availability.",
  "changeStoreMessagePromptDisclaimerV2": "Prices and availability may vary by restaurant.",
  "changeStoreSelectedOfferAndItemDisclaimer": "Your selected offer is not available for {serviceMode} and changing stores may change prices or item availability.",
  "changeStoreSelectedOfferDisclaimer": "Your selected offer is not available for {serviceMode}.",
  "changeStores": "Change Stores",
  "changingYourStoreDisclaimer": "Store changes may result in differences in price or item availability.",
  "chatWithSupport": "Chat with Support",
  "chatWithUs": "chat with us",
  "checkAvailability": "Check Availability",
  "checkCardBalance": "Check Card Balance",
  "checkForPricing": "One moment please! We’re checking with the Restaurant.",
  "checkNetworkSettings": "Check your network settings and try again",
  "checkingDeliveryAvailability": "Checking Delivery Availability",
  "checkingDeliveryAvailabilityText": "We are checking which restaurant will service your address. This may take a few moments.",
  "checkingPricesAvailability": "Checking prices and availability",
  "checkingWithRestaurant": "We're checking with the Restaurant.",
  "checkout": "Checkout",
  "checkoutPaymentMethodNeedRevaultError": "There was an issue with your payment method. Please re-add your payment method.",
  "cholesterol": "Cholesterol",
  "chooseADifferentPaymentMethodByPressingCancel": "You can choose a different payment method by pressing the Cancel button on the terminal.",
  "chooseALocation": "Choose a Location",
  "chooseATime": "Choose a Time",
  "chooseAnOption": "Choose an option...",
  "chooseAnotherLocation": "Choose Another Location",
  "chooseDifferentItem": "Please choose a different item.",
  "chooseDifferentOffer": "Please choose a different offer.",
  "chooseDrink": "Select Your Drink",
  "chooseItemAmount": "Choose {amount} {itemName}",
  "chooseLocation": "Choose location",
  "chooseMyRewardLevel": "Choose my Reward Level",
  "choosePaymentMethod": "Choose Payment Method:",
  "choosePromotion": "Choose a Promotion",
  "chooseSide": "Select Your Side",
  "chooseTheDefaultAmountToReloadYourGiftCard": "Set default Tim Card reload amount.",
  "chooseYourLocation": "Choose location",
  "chooseYourRewardLevel": "Choose Your Reward Level",
  "chooseYourSides": "Choose Your Sides",
  "city": "City",
  "cityRequiredError": "City is a required field",
  "cityStateZip": "City, State, or Zip",
  "claimPoints": "claim crowns",
  "clearFilter": "clear filter",
  "clearSearchBar": "Clear search bar",
  "clearText": "Clear Text",
  "clickHere": "Click here.",
  "clickHereForDetails": "Click here for details",
  "clickToSelectLocation": "Click to select location",
  "close": "Close",
  "closeDialog": "Close Dialog",
  "closeMessageToFindNearbyRestaurants": "Close this message to find other nearby restaurants",
  "closeMessageToFindNearbyStores": "Close this message to find stores near you that offer dine in, take out, or drive thru options.",
  "closeRestaurantInfoAccessibilityLabel": "Close restaurant details button, navigate back to the previous page",
  "closeWindow": "Close Window",
  "closed": "Closed",
  "closesAt": "Closes at {time}",
  "closesSoon": "Closes Soon",
  "closestStoreSelected": "We’ve selected the closest store to your current location.",
  "codeErrorMessage": "Couldn't retrieve your code.",
  "codeExpiredMessage": "Sorry, your promo code expired.",
  "codeExpiredMessageDetail": "Hit “Refresh” to get a new one.",
  "coffee": "Coffee",
  "comboOfferSavings": "Savings",
  "combobox": "combobox",
  "comeJoinTheTeam": "Come join the team",
  "comingSoon": "Coming soon!",
  "comments": "Comments",
  "communicationPreferences": "Communication Preferences",
  "community": "Community",
  "complete": "Complete",
  "completed": "Completed",
  "confettiRight": "confetti-right",
  "confirm": "confirm",
  "confirmAllItemsAreMissing": "Confirm all items are missing.",
  "confirmAndOrder": "Confirm & Order",
  "confirmArrival": "Confirm arrival",
  "confirmCTA": "Confirm",
  "confirmDeletePaymentMethod": "Are you sure you want to delete this payment method?",
  "confirmDeletePaymentMethodDeletionUnlink": "Are you sure you want to delete this payment method? Deletion will also unlink your card from your loyalty account and benefits.",
  "confirmDialogBody": "Please continue if you're ready to redeem in the restaurant.",
  "confirmDialogHeader": "This coupon will expire {br} in 15 minutes",
  "confirmOnlySomeItemsAreMissing": "Confirm only some items are missing.",
  "confirmYourPickupAddress": "Confirm Your Pickup Address",
  "confirmYourStore": "Confirm Your Store",
  "confirmationDifferentLocation": "Choose a different location",
  "confirmationPageInstructions": "Congratulations, we saved your order! Click I'm Here when you arrive to the restaurant",
  "congratulations": "Congratulations",
  "connectCard": "Connect card",
  "connectWithUs": "Connect with Us",
  "contact": "Contact",
  "contactCourier": "You can contact your courier at:",
  "contactRestaurantAt": "Please contact your restaurant at:",
  "contactSupport": "Contact Support",
  "contactUs": "Contact Us",
  "containsAllergens": "Contains: {allergens}",
  "containsAllergensDisclaimer": "Contains {allergens}",
  "containsSelectedOption": " contains selected level {rewardTier}",
  "contentCardsSeparatorLabel": "You are all caught up",
  "contentinfo": "contentinfo",
  "continue": "Continue",
  "continueChallenge": "Continue Challenge",
  "continueCustomizing": "Continue Customizing",
  "continueEditing": "Continue Editing",
  "continueInWeb": "Take me to website and send me a new code",
  "continueOrdering": "Yes, continue ordering",
  "continueQuest": "Continue Quest",
  "continueToCart": "Continue to Cart ({numberOfItemsInCart})",
  "continueWith": "Continue with",
  "continueWithEmail": "Continue with Email",
  "continueWithOffer": "Continue with this offer",
  "continueWithoutOffer": "Continue without offer",
  "cookieNotice": "Cookie Notice",
  "cookiePolicy": "By clicking \"{acceptCookies}\", you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts.",
  "cookiePolicyiOS14": "By clicking \"{acceptCookies}\", you agree to storing cookies on your device to enable features and analyze usage. We will not track you without consent.",
  "copy": "Copy",
  "couldNotLinkCard": "Couldn’t link your card",
  "couldNotLinkCardMessage": "We’re sorry we couldn’t link your card at this time. Please check if your card is already linked to another account. If not, check your connection and try again. Or chat with us for assistance.",
  "couldNotLocateStore": "The store could not be located to complete your order. Please try again later.",
  "couldntProcessOrder": "Please try placing your order in-restaurant and provide your 6-digit code, or select a different restaurant.",
  "couldntProcessPayment": "Unfortunately, we couldn't process your payment. Please take a moment to review your card information. If it looks correct, try submitting your order again.",
  "country": "Country",
  "countryRequiredError": "Country is a required field.",
  "couponApplied": "Coupon Applied",
  "couponEntryComingSoon": "coupon entry coming soon",
  "couponErrorBody": "Your order contains a coupon that's no longer available. You can still complete your order but we'll remove the coupon from the cart.",
  "couponErrorConfirm": "Complete Order",
  "couponErrorHeading": "Coupon Error",
  "couponOnlyAvailableOnPlatform": "Sorry, this coupon is only {br} available on our {platformName}",
  "couponWillExpire": "This coupon will expire in 15 minutes",
  "createAccountHeadline": "Create an Account to Get Started",
  "createAnAccount": "Create an Account",
  "createAnAccountErrors": "The form has {count, plural, one {# error} other {# errors}}.",
  "createAnAccountSubheader": "Welcome! You are creating an account using {email}",
  "credit": "Credit",
  "creditCardExpired": "Credit card number is expired",
  "creditCardNumber": "Card Number",
  "crownCard": "Crown Card",
  "crownCardBalance": "Crown Card Balance",
  "crownCardNumber": "Gift Card Number",
  "crownPoints": "Crown Points",
  "crowns": "Crowns",
  "crownsAllYours": "That's {points} Crowns — all yours!",
  "crownsApplied": "Crowns Applied",
  "crownsAwayFromUnlockingMoreRewards": "Crowns away from unlocking more rewards",
  "crownsEarned": "{points} Crown{points, plural, one {} other {s}} Earned",
  "crownsEarnedKeepGoing": "{crowns} Crowns earned — keep going!",
  "crownsPerDollar": "Earn {pointsPerDollar} Crown{pointsPerDollar, plural, one {} other {s}} for every dollar you spend",
  "crownsWillExpireOn": "Crowns will expire on",
  "curbside": "Curbside",
  "curbsideAt": "Curbside at",
  "curbsideHours": "Curbside hours",
  "curbsideInstructionsText": "Let us know when you've arrived and we will bring your order to your vehicle when it is ready. Otherwise, we will prepare your order at {time}",
  "curbsideInstructionsTextHere": "We have started preparing your order. Please park in a designated curbside parking spot and we will bring your order to your vehicle.",
  "curbsideOrder": "Curbside Order",
  "curbsideOrderError": "There was an error with your curbside order. Please confirm your details or try a different service mode.",
  "curbsideOrderPlaced": "Curbside Order Placed",
  "curbsideOrderReadyInstructions": "We will bring your order to your vehicle.",
  "curbsideOrderSaved": "Order Saved for Curbside",
  "curbsideUnavailable": "Curbside is currently unavailable",
  "curbsideVehicleDescription": "Help us find you by describing your vehicle e.g. red SUV/license plate starting ABC (optional). When you arrive at the restaurant, find a parking spot. When your order is ready, we will bring it you.",
  "curbsideVehicleDescriptionPlaceholder": "Vehicle description",
  "curbsideVehicleTitle": "Describe your vehicle",
  "currencyInfo": "The format of your currency is determined by your locale. Change your locale to update your format.",
  "currentBalance": "Current Balance: ",
  "currentPage": "current page",
  "currentServiceMode": "Current service mode",
  "currentServiceModeUnavailable": "The restaurant is not accepting {serviceMode} orders at this time. Change service mode or select a new store",
  "currentlyHaveXRewards": "You currently have {availableRedemptions} rewards",
  "customizations": "Customizations",
  "customize": "Customize",
  "customizeYour": "Customize your {name}",
  "cvv": "CVV",
  "cvvIsRequired": "CVV is required",
  "cvvMustBeAtLeast3Digits": "CVV must be at least 3 digits",
  "dashboard": "Dashboard",
  "date": "Date",
  "dateOfBirth": "Date of birth",
  "dateOfBirthIsBelowMinimum": "The information you entered does not comply with our {termsLink} and our {privacyPolicyLink}",
  "dateOfBirthIsRequired": "Date of Birth is required",
  "datePlaceholder": "mm/dd/yyyy",
  "day": "Day",
  "dayPlaceholder": "DD",
  "daypartAfterEndTime": "It's past {dayPart} time!",
  "daypartBeforeStartTime": "It's not {dayPart} time yet!",
  "daypartChallengedCompleted": "Challenge Completed",
  "daypartEndsAt": "{dayPart} ends at {endTime}",
  "daypartStartsAt": "{dayPart} starts at {startTime}",
  "days": "{days} Day{days, plural, one {} other {s}}",
  "daysLeft": "{daysCount} days left",
  "daytime": "Daytime",
  "daytimeMenu": "Daytime Menu",
  "daytimeMenuHeader": "{daytimeStartTime} - {daytimeEndTime}",
  "daytimeMenuHeaderHours": "{daytimeStartTime} to close",
  "deactivateCard": "Deactivate Card",
  "deactivateTimsCard": "Deactivate a Tims Rewards Card",
  "debit": "Debit",
  "december": "Decmber",
  "decline": "Decline",
  "declineCateringOrderModal": "Please select a reason as to why you cannot accept this order.",
  "declineOrder": "Decline Order",
  "declineReason": "Decline reason",
  "decrementAriaLabel": "decrement-{productName}",
  "decrementName": "Decrement {name}",
  "defaultForPayments": "Default for future payments",
  "defaultReloadMethod": "Default Reload Method",
  "delete": "delete",
  "deleteAccount": "Delete Account",
  "deleteAndDisable": "Delete and Disable",
  "deleteButtonText": "Delete",
  "deletePaymentMethod": "Delete payment method",
  "deliverHere": "Deliver Here",
  "deliverTo": "Deliver to",
  "delivered": "Delivered",
  "deliveringTo": "Delivering to",
  "deliveringToYourDoorAt": "Delivering to your door at",
  "delivery": "Delivery",
  "deliveryAddNewAddress": "Add new address",
  "deliveryAddress": "Delivery Address",
  "deliveryAddressFormatted": "{addressLine1}, {city}, {state} {zip}",
  "deliveryChangeRegionDisclaimer": "Please note you will need to enter your delivery address again. Changing regions may affect item availability.",
  "deliveryChangeRegionHeading": "Using this delivery address will change your region",
  "deliveryChangeRegionPrimaryText": "You have {userRegion} set as your region, while the delivery address you entered is in {restaurantRegion}.",
  "deliveryCheckingMessage": "We are checking which restaurant will service your address. This may take a few moments...",
  "deliveryClosed": "Delivery closed. Reselect your delivery address",
  "deliveryClosing": "Delivery ends in {minutes} min",
  "deliveryComingSoon": "Delivery COMING SOON",
  "deliveryDelivered": "Delivered",
  "deliveryDetails": "Delivery details",
  "deliveryDetailsInstructions": "Delivery Instructions (Optional)",
  "deliveryDriveEnroute": "Your driver will arrive soon!",
  "deliveryDriverArrived": "Driver Arrived",
  "deliveryDriverEnroute": "Driver Enroute",
  "deliveryFee": "Delivery Fee",
  "deliveryFeeDescription": "Fixed fee applicable to each delivery order.",
  "deliveryFees": "Delivery Order Fees",
  "deliveryFeesStripeFee": "Delivery",
  "deliveryFeesStripeGeographicalFee": "Location",
  "deliveryFeesStripeServiceFeePercent": "Service",
  "deliveryFeesStripeSmallCartFee": "Small Cart",
  "deliveryFeesStripeTier": "{fees} under {tier}",
  "deliveryFeesStripeTierEnd": "{fees} on orders {tier}+",
  "deliveryFeesStripeTitle": "Delivery Fees Apply",
  "deliveryFeesStripeTitleSuffix": "{amount} minimum order",
  "deliveryImage": "Delivery Image",
  "deliveryInfo": "Delivery Info",
  "deliveryInstructions": "Delivery Instructions",
  "deliveryIsUnavailable": "Delivery is unavailable in your area but don't let that stop you from enjoying our tasty treats. Click on the button below to find restaurants in your area and don't forget to checkout our deals!",
  "deliveryIsUnavailable.th": "Delivery is unavailable in your area but don't let that stop you from enjoying our tasty treats. Find restaurants in your area that you can place a takeout order at or make an order for delivery with one of our partners!",
  "deliveryLogoAlt": "Delivery service provider logo",
  "deliveryMinumumNotReached": "Sorry! Minimum order subtotal for delivery is {min}",
  "deliveryNotAvailable": "Delivery Unavailable",
  "deliveryOnly": "Delivery only",
  "deliveryOrder": "Delivery Order",
  "deliveryOrderBeingPrepared": "Being Prepared",
  "deliveryOrderPlaced": "Delivery Order Placed",
  "deliveryPhoneDisclosure": "Your phone number is required so that we can send you updates about your order and facilitate communication between you and your driver. Your phone number will not be visible to your driver.",
  "deliveryPhoneNumberError": "Please update your account phone number to continue",
  "deliveryPlaced": "Thanks. We received your Order",
  "deliveryPrepared": "Your order is being prepared",
  "deliverySelectYourAddress": "Select your Delivery Address",
  "deliveryShouldSaveInfoCheckboxMessage": "Save my information for updates on order status and driver communication. Your number will not be visible to the driver.",
  "deliveryStatusDriverAssigned": "Your order is in the works",
  "deliveryStatusDriverAtCustomer": "Your courier is nearby!",
  "deliveryStatusDriverAtStore": "Your courier just picked up your order",
  "deliveryStatusDriverStarting": "Your courier is picking up your order",
  "deliveryStatusDriverUnassigned": "Your order is in the works",
  "deliveryStatusOrderAbandoned": "Your order has been delivered",
  "deliveryStatusOrderCancelled": "Your order has been cancelled",
  "deliveryStatusOrderCreated": "Your order is in the works",
  "deliveryStatusOrderDroppedOff": "Your order has been delivered",
  "deliveryStatusOrderError": "Error processing your order",
  "deliveryStatusOrderPickedUp": "Your courier is out for delivery!",
  "deliveryStatusOrderTimeout": "Timeout processing your order",
  "deliveryStatusQuoteError": "Error processing your order",
  "deliveryStatusQuoteRequested": "We are processing your order",
  "deliveryStatusQuoteSuccessful": "We received your order",
  "deliveryStatusQuoteUnavailable": "We can't process your order",
  "deliverySurcharge": "Delivery Surcharge",
  "deliverySurchargeMessage": "A {feeSurcharge} surcharge will be added to your delivery fee due to the distance between your delivery location and the nearest restaurant.",
  "deliveryTerms": "Delivery terms and fees apply.\nPrices may be higher than at restaurants.\n{link}.",
  "deliveryTerms.ca.heading": "Canadian Delivery Fees:",
  "deliveryTerms.ca.mobileTitle": "Mobile Order and Payment Terms",
  "deliveryTerms.caFeeValue": "$3.00",
  "deliveryTerms.californiaHeading": "California:",
  "deliveryTerms.coloradoHeading": "Colorado:",
  "deliveryTerms.fee.ca.gte12.label": "Delivery on Orders ≥$12:",
  "deliveryTerms.fee.ca.gte12.value": "$2.99 Delivery Fee + 10% Service Fee",
  "deliveryTerms.fee.ca.lt12.label": "Delivery on Orders <$12:",
  "deliveryTerms.fee.ca.lt12.value": "$2.99 Delivery Fee + 10% Service Fee + $1.99 Small Cart Fee",
  "deliveryTerms.feeLabel": "Delivery Fee:",
  "deliveryTerms.feeValue": "$2.99 ($0 for orders $25+)",
  "deliveryTerms.intro": "Delivery offered at participating U.S. restaurants on the BK App and bk.com. Minimum $5 order required (before taxes and fees). Prices higher than at restaurants. BK account registration is required. Delivery powered by third-party delivery providers, and subject to availability and restaurant delivery hours. Print coupons are not valid on delivery orders. Not all digital offers are available on delivery. Check digital offer terms at bk.com/offers before ordering. Fees are based on order subtotal.",
  "deliveryTerms.intro.ca.part1": "Delivery offered at participating Canadian restaurants on the BK App and burgerking.ca. Delivery powered by third-party delivery providers, and subject to availability and restaurant delivery hours.",
  "deliveryTerms.intro.ca.part2": "Prices may be higher than at restaurants. Delivery order fees: Delivery Fee, Service Fee and Small Cart Fees may apply.",
  "deliveryTerms.intro.ca.part3": "Print coupons not valid on delivery orders. Not all digital offers available on delivery. Check digital offer terms at burgerking.ca/rewards/offers before ordering.",
  "deliveryTerms.retailFeeLabel": "Colorado Retail Delivery Fee:",
  "deliveryTerms.retailFeeValue": "A $0.29 Retail Delivery Fee is required by law for deliveries in the State of Colorado",
  "deliveryTerms.serviceFeeLabel": "Service Fee:",
  "deliveryTerms.serviceFeeValue": "15% of order subtotal",
  "deliveryTerms.smallCartLabel": "Small Cart Fee:",
  "deliveryTerms.smallCartValue": "$2.50 on orders under $10",
  "deliveryTerms.statesHeading": "All states (except California and Colorado):",
  "deliveryTerms.title": "Delivery on the BK App and bk.com",
  "deliveryTerms.title.ca": "Delivery on the BK App and burgerking.ca",
  "deliveryTermsHeading": "Delivery Terms",
  "deliveryTermsPrefix": "Delivery terms and fees apply. Prices may be higher than at restaurants. ",
  "deliveryTime": "Delivery Time",
  "deliveryUnavailable": "Delivery - Unavailable",
  "depositFee": "Deposit Fee",
  "describeIssue": "Describe your issue",
  "describeIssueAndIncludePhoneNumber": "Describe your issue (please include your phone number)",
  "describeYourVehicle": "Describe your vehicle",
  "descriptionLengthError": "Description must be between {min} to {max} characters long",
  "details": "Details",
  "deviceSettings": "Device Settings",
  "diagnostics": "Diagnostics",
  "dialog": "dialog",
  "didNotReceiveCodeHeading": "Didn't receive a code?",
  "differentDeviceError": "We noticed this isn't the device you requested this code from. To login with this device, please request a new code below.",
  "differentDeviceErrorPhoneVerify": "We noticed this isn't the device you requested this code from. To verify your phone number, please press the link again.",
  "differentRegion": "a different region",
  "digitalWalletsAndCreditCards": "Digital Wallets and Credit Cards",
  "dineIn": "Dine In",
  "dineInAt": "Dine in at",
  "dineInComingSoon": "Dine In COMING SOON",
  "dineInHours": "Dine in hours",
  "dineInOrder": "Dine In Order",
  "dineInOrderPlaced": "Dine In Order Placed",
  "dineInUnavailable": "Dine In is currently unavailable",
  "directions": "Directions",
  "discard": "Discard",
  "discardChanges": "Discard Changes",
  "dismiss": "Dismiss",
  "dismissDeliveryModal": "Dismiss",
  "distance": "Miles",
  "diversity": "Diversity",
  "doItManually": "I'll do it manually",
  "doYouHaveACouponAlready": "Do You Have A Coupon Already?",
  "donateTo": "Donate To {link}?",
  "donation": "Donation",
  "done": "Done",
  "dontForgetToOrderYourReward": "Don't forget to order your reward!",
  "dontForgetToPickYourOrder": "Don’t forget to pick up your order soon! The restaurant closes at {time}",
  "dontHaveAPromoCode": "Don't have a promo code?",
  "dontHaveAnAccount": "Don't have an account yet?",
  "dontHaveWalmartAccount": "Sign up for a Walmart+ annual membership",
  "dontHaveWalmartAccountMonthly": "Sign up for a Walmart+ monthly membership",
  "dontHaveWalmartPlusAccount": "Don’t have a Walmart+ membership yet? No problem!",
  "downArrowChevronIcon": "Down Arrow",
  "downloadApp": "Download Our App",
  "downloadOnAppStore": "Download on the App Store",
  "downloadOurApp": "Download our App. Enter your mobile number and we'll send you a download link.",
  "downloadTheApp": "Download the App",
  "drawerHeading": "drawer-heading",
  "driveThru": "Drive Thru",
  "driveThruAndCounter": "Drive Thru & Counter",
  "driveThruAt": "Drive-thru at",
  "driveThruComingSoon": "Drive Thru COMING SOON",
  "driveThruHours": "Drive Thru hours",
  "driveThruMobileOrderPlaced": "Mobile Order Drive Thru Placed",
  "driveThruOrder": "Drive Thru Order",
  "driveThruOrderPlaced": "Drive Thru Order Placed",
  "driveThruPickupInstructions": "Drive up to the ordering screen and let us know you ordered online for {name}.",
  "driveThruUnavailable": "Drive Thru is currently unavailable",
  "duplicate": "Duplicate",
  "duplicateAccounts": "Duplicate Accounts",
  "duplicateSupportFormSubmission": "A support ticket was already created for your issue. Please give us up to 48 hours to respond",
  "earnCrowns": "Earn Crowns",
  "earnCrownsPerDollarSpent": "Earn 10 Crowns for every dollar you spend on the BK app or BK.com",
  "earnPoints": "Earn Crowns",
  "earnPointsForEveryPurchase": "Earn 10 crowns for every eligible purchase",
  "earnPointsToRedeem": "Earn Crowns to redeem",
  "earnTab": "Earn",
  "earnUsingRewardsCard": "Earn using Rewards Card",
  "earned": "You've earned",
  "earnedPoints": "Transaction History",
  "earnedReward": "You just earned a reward",
  "earnedTimsRewardsVisits": "Earned Tims Rewards Visits",
  "eatIn": "Eat In",
  "edit": "Edit",
  "editAddress": "Edit Address",
  "editAddressFailed": "Unable to update address. Please try again.",
  "editFavorite": "Edit Favorite",
  "editOrder": "Edit Order",
  "eggs": "eggs",
  "email": "Email",
  "emailAddress": "Email Address",
  "emailAddressDoesNotMatch": "Email address does not match",
  "emailOrPhoneNumberRequiredError": "Email or phone number is required",
  "emailPushPreferencesDescription": "Be the first to know about new menu items and offers.",
  "emailPushPreferencesTitle": "Updates and Offers",
  "emailRequiredError": "Email is a required field.",
  "emailSuccessfullySubmitted": "Email successfully submitted",
  "emailVerificationSent": "Email sent! Please check your email for the verification link.",
  "emptyCart": "Empty Cart",
  "emptyCartMessage": "You don't have anything in your cart yet!",
  "emptyInboxCaption": "We are cooking something...hold on tight, we’ll let you know",
  "emptyInboxTitle": "Nothing new for now...",
  "emptyMenuHeading": "Select a Location to View Menu",
  "emptyMenuMessage": "Help us find your closest store by sharing your location or select a location manually",
  "emptyMyCodeHeading": "Select a Location to view My Code",
  "emptyMyCodeMessage": "Share your location or select a location manually to view My Code",
  "emptyOffersHeading": "Select a Location to View Offers",
  "emptyStateTimCTACopy": "Get Started",
  "emptyStateTimCardCopy": "Scan to pay will become available after your first digital purchase, or by transferring in a Tim Card® balance",
  "emptyStateTimCardHeadline": "Tim Card",
  "enableCameraPermission": "Please, enable camera permission",
  "enableLocationServices": "Enable Location Services",
  "enablePushNotificationsOnDevice": "To receive notifications from Burger King, you must first enable notifications in your device's settings.",
  "ends": "ends",
  "endsIn": "••••",
  "endsInRedesign": "*",
  "english": "English",
  "enjoyYourOrder": "Enjoy your order. See you soon!",
  "enterACode": "Enter A Code",
  "enterANameForThisOrder": "Enter a name for this order",
  "enterAPromoCode": "Enter a Promo Code",
  "enterAddressOrDrag": "Enter an address or drag the map to find stores near you.",
  "enterCardNumber": "Enter card number",
  "enterFourDigitPin": "Enter the 4-digit code from a printed coupon, BK.com, or mobile app here:",
  "enterManually": "Enter manually",
  "enterPromoCode": "Enter Promo Code",
  "enterReceiptCode": "Enter Receipt Code to Earn",
  "enterVerificationCode": "Enter Verification Code",
  "enterYourDeliveryAddress": "Enter your address",
  "enterYourLovedOnesDeliveryAddress": "Enter your (or your loved one's) delivery address",
  "error.isRestaurantPosOnline": "Restaurant POS offline",
  "error.isStoreOpenAndAvailable": "Store is not open and available",
  "error.priceMutationError": "Price mutation error",
  "error.priceOrderFailure": "Price order failure",
  "error.unavailableCartItems": "Unavailable cart items",
  "error404": "Error 404",
  "errorBoundaryBody": "Something went wrong on our end. Take a look at our menu and offers while we take a look into this.",
  "errorBoundaryTitle": "Bummer",
  "errorCreateOrder": "An error occurred creating the order",
  "errorCreatingSupportCase": "There was an error submitting your support case. Please try again",
  "errorDialogCooldownMessage": "We're currently preparing a similar order for you, are you sure you want to order again?",
  "errorDialogCooldownTitle": "Order in Progress",
  "errorDialogFavoriteStoreMessage": "To set a favorite store, first sign up or log in to an account.",
  "errorDialogFavoriteStoreTitle": "Log in required",
  "errorLoadOffers": "An error occurred loading offer redemptions",
  "errorLoadingUserOrders": "Error Loading User Orders",
  "errorProcessingRequest": "Looks like there was an error processing your request.",
  "errorRetrievingFavoriteRestaurants": "Could not retrieve favorite restaurants",
  "errorRetrievingRecentRestaurants": "Could not retrieve recent restaurants",
  "errorRetrievingRestaurants": "Could not retrieve restaurants",
  "errorSavingApplePass": "There was an error saving this card to Apple Wallet",
  "errorSavingGooglePass": "There was an error saving this card to Google Pay",
  "errorWithPayment": "Something went wrong with your payment, please try a different form of payment.",
  "eta": "ETA",
  "etaFull": "Estimated Time of Arrival",
  "eu-calories": "Energy",
  "eu-carbohydrates": "Carbohydrates",
  "eu-cholesterol": "Cholesterol",
  "eu-fat": "Fat",
  "eu-fiber": "Fiber",
  "eu-proteins": "Proteins",
  "eu-salt": "Salt",
  "eu-saturatedFat": "Of which saturates",
  "eu-sodium": "Sodium",
  "eu-sugar": "Of which sugars",
  "eu-transFat": "Trans Fat",
  "eu-weight": "Weight",
  "euNutritionValues": "{calories} / {joules}",
  "evening": "Evening",
  "everythingYouLove": "Everything you love about Tim Hortons, now 'byte'-sized!",
  "exampleInstructions": "e.g., Please leave delivery at the door",
  "exceedsBalanceLimit": "Exceeds Balance Limit",
  "exceedsBalanceLimit.th": "Tim Card balance cannot be larger than $100",
  "exceedsRewardsBalance": "If you add this reward to your cart, you will exceed your current Crowns balance. Please remove the Crowns applied in your cart.",
  "exclusiveDeals": "Exclusive Deals",
  "existingUserVerifiedPhone": "An existing user has already verified this phone number. Please try another phone number.",
  "exitDeliveryAddressMessage": "Exit Delivery Address With Unsaved Changes",
  "expirationDate": "Expiration Date",
  "expirationDateIsRequired": "Expiration date is required",
  "expire": "exp.",
  "expired": "Expired",
  "expiredCard": "Expired Card",
  "expires": "Expires",
  "expiresIn": "Expires in {expiryDays} {expiryHours}",
  "expiresWithDate": "Expires {endDateText}",
  "expiring": "expiring",
  "expiringPoints": "Expiring Crowns",
  "expiringWithDate": "expiring {expiringDate}.",
  "exploreOurMenu": "Explore Our Menu",
  "faq": "Frequently Asked Questions",
  "fastLaneDriveThru": "Fast Lane Drive Thru",
  "fastLaneDriveThruDescription": "Drive up and let us know you placed an online order.",
  "fastest": "Fastest",
  "fat": "Fat",
  "favorite": "Favorites",
  "favoriteLocationLabel": "Search Favorite Location",
  "favoriteLocationPlaceholder": "Select your location",
  "favoriteLocationRequiredError": "Favorite location is required.",
  "favoriteOrders": "Favorite Orders",
  "favoriteRemoveAllModalBody": "Removing all the items in this order will delete your favorite. Are you sure you want to delete this order?",
  "favoriteRemoveAllModalHeader": "Wait! You have no items!",
  "featured": "Featured",
  "february": "February",
  "fee": "Fee",
  "fees": "Fees",
  "feet": "feet",
  "fetchCoordinatesError": "We couldn’t find coordinates for the selected address. Please try again.",
  "fhsLogoTitle": "Firehouse Subs",
  "fiber": "Fiber",
  "fifteenMin": "15 min",
  "fileDownloadedMessage": "The file has been downloaded successfully.",
  "fileDownloadedTitle": "File Downloaded",
  "filter": "filter",
  "filterByMonth": "Filter by month",
  "filters": "filters",
  "findARestaurant": "Find a Restaurant",
  "findAStoreNearMe": "Find a store near me",
  "findATims": "Find a Tim Hortons",
  "findRestaurants": "Find Restaurants",
  "findRewardYouWantToRedeem": "Find the reward you want to redeem and click \"Redeem at Restaurant\".",
  "finish": "Finish",
  "finishOrder": "Finish order",
  "finishYourProfile": "Complete your profile",
  "firstName": "First name",
  "fish": "fish",
  "fiveMin": "5 min",
  "followUsOnFacebook": "Follow us on Facebook",
  "followUsOnInstagram": "Follow us on Instagram",
  "followUsOnTiktok": "Follow us on TikTok",
  "followUsOnTwitter": "Follow us on Twitter",
  "followUsOnYoutube": "Follow us on YouTube",
  "foo": "foo",
  "foodQuality": "Food Quality",
  "forInternalUseOnly": "For Internal Use Only",
  "forItemAvailability": "For availability",
  "forYourConvenienceWeHavePickedClosestStore": "For your convenience we’ve picked the closest store to your location.",
  "forceUpdateModalCaption": "Update Required.",
  "forceUpdateModalSubCaption": "Download the latest version of the app to keep on flame-grilling.",
  "forceUpdateModalTitle": "News Flash!",
  "forterSignUpError": "It seems that you may already have an account with us. Please try logging in to your existing account or contact support for assistance.",
  "forwardButton": "Forward Button",
  "foundation": "Foundation",
  "franchising": "Franchising",
  "free": "FREE",
  "freeCoffeeTeOrBakedGood": "Earn a FREE coffee, tea or baked good.",
  "freeDeliveryOnAllOrders": "Free Delivery on All Orders",
  "freeDeliveryOverAmount": "$0 Delivery Fee on orders over {amount}",
  "freeRewardsUpsize": "Free Rewards Upsize",
  "freeUpsize": "Update Cart",
  "french": "French",
  "frequencyChallengedCompleted": "Challenge Completed",
  "freshNewDownload": "Fresh New Download",
  "freshlyExtracting": "Freshly extracting...",
  "friday": "Friday",
  "from": "From",
  "fromStartDateToEndDate": "From {startDate} to {endDate}",
  "fromStoreAddress": "from {storeAddress}",
  "frozens": "Frozens",
  "fullMenu": "Full Menu",
  "fundingSource": "Funding Source",
  "futureDateOfBirthProvided": "Date of birth cannot be a future date",
  "generateNewCode": "Generate New Code",
  "geographicalFee": "Geographical Fee",
  "geographicalFeeCO": "CO Retail Delivery Fee",
  "geographicalFeeDescription": "Additional fee charged in your area by the delivery aggregator.",
  "geolocationDeliveryImageAlt": "Geolocation delivery image",
  "geolocationImageAlt": "Geolocation image",
  "germany": "Germany",
  "getDirections": "Get Directions",
  "getMyDisccountButton": "Get My Discount",
  "getMyDiscount": "Join Walmart+",
  "getMyOffers": "Get My Offers",
  "getOnGooglePlay": "Get it on Google Play",
  "getRewards": "Get rewards",
  "gift": "Gift",
  "giftCard": "Gift Card",
  "giftCardAddingError": "Gift card details may be incorrect or we are experiencing issues with your card, please try again or check with the issuer.",
  "giftCardAddingSuccess": "Your BK Gift Card has been added!",
  "giftCardAlreadyRedeem": "Gift Card was already redeemed.",
  "giftCardExists": "Gift Card already exists in payment methods. You can only have one gift card in payment methods.",
  "giftCardImageAltText": "TimCard",
  "giftCardNumber": "Gift Card Number",
  "giftCardNumber.bk": "Gift Card Number",
  "giftCardNumberIsNotValid": "Gift Card Number is not valid",
  "giftCardNumberIsRequired": "Gift Card number is required",
  "giftCardUnavailableAtLocationError": "Prepaid Cards are unavailable at this location. Please select another form of payment.",
  "giftCardUnavailableAtLocationErrorHeading": "Payment Failed",
  "giftSent": "Gift on the way!",
  "giftSentError": "Unfortunately, we were not able to send the {gift} to {email}. Please try again or contact {supportLink}.",
  "giftSentSuccess": "You have gifted a {gift} to {email}.",
  "gluten": "gluten",
  "goToDeviceSettings": "Go to your device settings to allow camera access. We use your camera to let you take photos within the app",
  "goToHomepage": "Go to Homepage",
  "goToMenu": "Go To Menu",
  "goToPaymentMethods": "Go to Payment Methods",
  "goToPopeyes": "Go to Popeyes",
  "goToScanPage": "Go To Scan Page",
  "goodDayPeriodX": "Good {dayPeriod}, {name}",
  "googlePay": "Google Pay",
  "googlePayPaymentNotAvailable": "We currently don’t accept Google Pay on our websites. Please select or add a new payment method.",
  "googlePlay": "Google Play",
  "gotIt": "Got It!",
  "gotToDeviceSettingsButton": "Go to Settings",
  "gotToDeviceSettingsButtonWeb": "Allow Camera",
  "grabYourReward": "Grab your reward!",
  "hamburgerMenuAriaLabel": "Navigate to account menu",
  "haveFreeReward": "You have a Free Reward",
  "haveItYourWay": "Have it your way",
  "haveNotReceivedAuthCode": "If you don't receive a code after 3 minutes, you can request a new code.",
  "haveNotReceivedAuthEmail": "Didn't receive an email? If you don't receive an email after 3 minutes, check your spam folder, or {link}",
  "headToRestaurant": "Head to restaurant",
  "headsUpModalTitle": "Heads up",
  "help": "Help",
  "here": "here",
  "hiX": "Hi, {name}",
  "hideDetails": "Hide Details",
  "highVolumeMessage": "We are currently experiencing higher volumes than expected. We apologize for the longer wait times and are doing our best to serve you as soon as possible. Thank you for understanding.",
  "higherPricesWarning": "Prices may be higher",
  "history": "history",
  "historyTab": "History",
  "historyTitle": "History",
  "hockey1": "Hockey - 1 Pick",
  "hockey2": "Hockey - 2 Picks",
  "hockey3": "Hockey - 3 Picks",
  "home": "Home",
  "homeMainFabSignInUp": "Log In / Sign Up",
  "homepage": "Homepage",
  "hours": "Hours",
  "hoursAndInfo": "Hours & Info",
  "hoursOfOperationFallbackMessage": "Closed",
  "howItWorks": "How It Works",
  "howItWorksLower": "How it works",
  "howToRedeem": "How to Redeem",
  "howToUseTimCard": "Use your Tim Card to pay for your items. You can reload your Tim Card at any time in your profile.",
  "howWouldYouLikeToReceiveThisOrder": "How would you like to receive this order?",
  "howWouldYouLikeToRedeemYourTimCardToday": "How would you like to redeem your TimCard today?",
  "huaweiDownloadApp": "Huawei Download app button",
  "iAmHereButtonText": "I am here",
  "iHaveArrived": "I Have Arrived",
  "ifYouArePayingInRestaurant": "if you are paying in-restaurant",
  "imClose": "I'm Close",
  "imCraving": "I'm craving",
  "imHere": "I'm Here",
  "image": "image",
  "inRestaurantOrder": "Order In-Restaurant ",
  "inStoreAmenities": "In-Store Amenities",
  "inStoreTitle": "In Store Code",
  "inWithLove": "in with Love",
  "incentiveFeedbackCartRequirement": "Add the required items to your cart in order to redeem.",
  "incentiveFeedbackCartRequirementExclusion": "Can't be combined with:",
  "incentiveFeedbackDefault": "Your cart does not meet the requirements to redeem this {incentiveType}.",
  "incentiveFeedbackExpired": "This offer expired on {endDate}.",
  "incentiveFeedbackInvalidDay": "This offer is only valid on {targetValue}.",
  "incentiveFeedbackInvalidStore": "This {incentiveType} is not available at your selected restaurant.",
  "incentiveFeedbackInvalidTime": "This {incentiveType} is only valid between {startTime} and {endTime}. Check back at {startTime} to redeem!",
  "incentiveFeedbackMaxRedemptions": "You have surpassed your allotted redemptions for this {incentiveType}.",
  "incentiveFeedbackNotAvailableInStore": "Not available at this location",
  "incentiveFeedbackOfferNotAvailable": "Sorry, your offer is no longer available.",
  "incentiveFeedbackOutOfDayPart": "Currently not available. Please check back later!",
  "incentiveFeedbackOutOfDayPartTime": "Available starting at {time}",
  "incentiveFeedbackPaymentMethod": "You must pay with {targetValue} in order to redeem this {incentiveType}.",
  "incentiveFeedbackServiceMode": "This {incentiveType} is only available for {targetValue}.",
  "incentiveFeedbackSubtotal": "Your subtotal must be ${targetValue} to redeem this {incentiveType}. Add ${calculatedValue} to redeem.",
  "incentiveFeedbackWithinCooldown": "You have recently used an offer. You will be able to use another one in {calculatedValue} minutes.",
  "incidentInvolvingYourSafety": "Incident involving your safety.",
  "includeRewardItem": "Include the reward item when placing your order. Scan before paying to use your Crowns.",
  "included": "Included",
  "includedInYourOrder": "Included In Your Order",
  "incomplete": "Incomplete",
  "incrementAriaLabel": "increment-{productName}",
  "incrementName": "Increment {name}",
  "incrementRollText": "{rollsToShare} RRROLL{rollsToShare, plural, one {} other {S}}",
  "info": "Info",
  "information": "Information",
  "initializationNetworkRedirectNote": "<Bold>Please note:</Bold> Changes to your rewards tier and crowns may not be reflected right away.",
  "initializationNetworkRedirectOffline": "We are currently experiencing network issues. You are currently in offline mode. <Bold>You will only be earning crowns when you Scan.</Bold>",
  "instructions": "Instructions",
  "instructionsPlaceholder": "Tell the driver where to leave your order",
  "instructionsTooLong": "Instructions must be less than 200 characters.",
  "insufficientBalanceReloadAgain": "Insufficient prepaid balance, please reload again to checkout.",
  "internalError": "Internal Error",
  "international": "International",
  "invalidAddressLine2": "Name is missing. Please enter your name.",
  "invalidCardNumber": "Invalid Card Number",
  "invalidCode": "Invalid Code!",
  "invalidDateMissingFields": "Invalid date: {missingFields} {count, plural, one {field is} other {fields are}} required",
  "invalidDateOfBirthProvided": "Invalid date of birth provided",
  "invalidEmail": "Invalid Email",
  "invalidEmailProvided": "Invalid email provided",
  "invalidInstructions": "Instructions contain unsupported characters.",
  "invalidLink": "Invalid Link",
  "invalidOfferError": "Your offer is invalid.",
  "invalidOffersRemoved": "Invalid offers have been removed.",
  "invalidOtpProvided": "The code you entered doesn't match the code we sent. Check your messages and try typing it in again.",
  "invalidPaymentCardTypeWithOffer": "Your selected payment method can not be applied to your current offer. Update your payment method to continue.",
  "invalidPaymentMethodError": "Your payment method is invalid. Please try a different payment method",
  "invalidPhoneNumber": "The phone number is not valid. Please try again",
  "invalidPhoneNumberFormat": "Invalid phone number format. Please enter a valid number.",
  "invalidQrCode": "Invalid QR code, please try another",
  "invalidReloadError": "We were unable to reload your card",
  "invalidTipAmountError": "Please submit a valid tip amount.",
  "invalidVehicleDescription": "Please enter your Vehicle Description to proceed or try a different service mode.",
  "invalidVerification": "Invalid Verification. Re-enter code below:",
  "inventory": "Inventory",
  "investorRelations": "Investor Relations",
  "investors": "Investors",
  "iosDownloadApp": "IOS Download app button",
  "isHalalTitle": "halal restaurant",
  "issueWithMyItems": "Issue with my item(s)",
  "issuesDuringExperience": "If you experienced any issues during your ordering experience, please",
  "item": "Item",
  "itemAddedToCart": "One {itemName} has been added to your cart.",
  "itemCurrentlyNotAvailable": "Item is currently unavailable!",
  "itemFavorited": "Item saved to favorites!",
  "itemFavoritedError": "Oops! There was an error with your favorite. Please try again later.",
  "itemFavoritedRemove": "Item removed from favorites!",
  "itemModifiers": "Item Modifiers",
  "itemNotAvailable": "Item not available",
  "itemTotal": "Item Total",
  "items": "Items",
  "itemsInThisOrder": "Items in this Order",
  "itemsNeverArrived": "Item(s) Never Arrived",
  "itemsUnavailable": "Items Unavailable",
  "itemsUnavailableAtStore": "Items Unavailable at this Store",
  "itemsUnavailableDialogStoreLocatorBody": "We will remove these items from your cart or you can keep your previous store.",
  "itemsWithNutrients": "I want items with",
  "itsUsNotYou": "It's us, not you...",
  "january": "January",
  "joinNow": "Join Now",
  "joinWalmart": "Join Walmart+",
  "july": "July",
  "june": "June",
  "justMoreToReachNextLevel": "Just {points} more to reach the next level",
  "keepAddress": "Keep Address",
  "keepCurbsideOrder": "No, Keep Order",
  "keepCurrentLocation": "Keep Current Location",
  "keepPaymentMethod": "Keep Payment Method",
  "keepPreviousStore": "Keep Previous Store",
  "keepPurchasingItemsToEarnRewards": "Keep purchasing items to earn rewards and redeem.",
  "keepPurchasngItemsToEarnRewards": "Keep purchasing items to earn rewards and redeem.",
  "kilometers": "km",
  "languageAndRegion": "Language and Region",
  "languageAndRegionSelector": "Language and region selector",
  "learnMore": "Learn More",
  "leaveNow": "Leave Now",
  "leaveOrderBay": "Leave Order Bay",
  "leaveOrderBayAriaLabel": "Link to leave Order Bay ordering",
  "leaveOrderBayModalBody": "You will need to drive away to place your order",
  "leaveOrderBayModalConfirm": "Leave",
  "leaveOrderBayModalHeading": "Leave Order Bay?",
  "leaveWithoutSaving": "Leave Without Saving",
  "left": "Left",
  "legacyImportWelcomeMessageHeader": "Welcome! Bonjour!",
  "legacyImportWelcomeMessageText": "We've updated our app. Please follow the link below to sign back in",
  "legal": "Legal",
  "legalNotice": "Legal Notice",
  "lessOptions": "Less Options",
  "letTheCashierKnowYouPlacedAKioskOrderFor": "Let the cashier know you placed a kiosk order for",
  "letUsKnowWhenYourAreHere": "Let us know when you are here.",
  "letUsKnowYouOrderedForX": "Drive up to the ordering screen and let us know you ordered online for {name}",
  "letsEat": "Let's eat",
  "letsFindARestaurantToStartOrdering": "Let’s find a Restaurant to Start Ordering and to Redeem your Walmart+ Offers",
  "letsGetStarted": "Let's get started, {userName}!",
  "letsGo": "Let's go!",
  "letsLoadX": "Let's load {amount} to get you started.",
  "limitReached": "Limit Reached",
  "limitedTimeOffer": "Limited time offer",
  "linkARewardsCardToYourAccountAndRedeem": "Link a Rewards card to your account and redeem all crowns stored in there.",
  "linkMyCard": "Link my card",
  "linkOpensInNewTab": "Link opens in new tab",
  "linkWithDifferentAccount": "Link with a different account",
  "linkWithThisAccount": "Link with this account",
  "linkYourCardDescription": "Link your card to see your Crowns. Enter your Tims Rewards number on the back of your card to link it with your account.",
  "list": "List",
  "listOfWordsLayout": "{position, select, first {} last { and } other {, }}{word}",
  "listOfWordsLayoutOr": "{position, select, first {} last { or } other {, }}{word}",
  "listbox": "listbox",
  "loadCard": "Load Card",
  "loadLoyaltyError": "There was an error loading your loyalty card.",
  "loadMore": "Load More",
  "loadNow": "Load Now",
  "loadTimCard": "Load Tim Card",
  "loadWith": "Load with",
  "loadXOnTimCard": "Load {amount} on Tim Card",
  "loadYourTimCard": "Load your Tim Card",
  "loading": "One moment please!",
  "loadingMenu": "Loading Menu",
  "loadingRestaurantMenu": "One moment please! We are loading our menu.",
  "loadingYourExperience": "Loading your personalized experience",
  "loadingYourOrder": "Loading Your Order",
  "localeDateTime": "en-US",
  "location": "Location",
  "locationClosed": "Location closed. Mobile ordering is currently unavailable.",
  "locationDisclaimer": "We use your location to help you find nearby restaurant and provide you with more relevant marketing & offers.",
  "locationPermissionActionButton": "Share Location",
  "locationPermissionContent": "Sharing your location will help us make sure your order is hot and ready by the time you arrive.",
  "locationPermissionDismissButton": "Maybe Later",
  "locationPermissionTitle": "Timing Is King",
  "locationSearch": "We are looking for restaurants.",
  "locationServiceMessageMapView": "Enter an address or use the map. For the best experience, we recommend enabling location services.",
  "locations": "Locations",
  "locatorChangeRegionDisclaimer": "Please note you will need to select your restaurant again. Changing regions may affect item availability.",
  "locatorChangeRegionHeading": "Selecting this location will change your region",
  "locatorChangeRegionPrimaryText": "You have {userRegion} set as your region, while this store is in {restaurantRegion}.",
  "locatorChangeRegionSelection": "Please select a new region to continue.",
  "locked": "Locked",
  "lockedOfferExpires": "Expires in {days} days, {hours} hours",
  "lockedOfferImage": "Locked offer image",
  "lockedPromoCodeOffer": "Use code to redeem",
  "logIn": "Log In",
  "logInDisclaimer": "Not your computer? Please make sure to log out before you leave",
  "logInToRedeem": "Log in to earn and redeem rewards",
  "logInToRedeemOnline": "Log in to Redeem Online",
  "logInWithApple": "Continue with Apple",
  "logInWithExistingEmail": "An account with the given email already exists. Would you like to log in instead?",
  "logInWithFacebook": "Continue with Facebook",
  "logInWithGoogle": "Continue with Google",
  "logOut": "Log Out",
  "logo": "BK logo",
  "looksLikeThereWasAnIssue": "Looks like there was an error processing your request.",
  "looksLikeWereExperiencingIssues": "Looks like we are experiencing issues. Please try again!",
  "lostCardDescription": "If your Tims Rewards card is lost or stolen, you may disable and remove it from your account. Don't worry, your transactions and rewards will be saved to your account.",
  "lostNetworkConnectivity": "Looks like you have lost network connectivity",
  "lostTimCard": "Lost your Tims Rewards card?",
  "lostYourTims": "Lost Your Tims Rewards Card",
  "loyaltyBannerDashboardButtonLabel": "Dashboard",
  "loyaltyBannerDetailsButtonLabel": "Details",
  "loyaltyBannerLoggedOutMessage": "Welcome! You can earn Crowns with every purchase and use them to redeem rewards.",
  "loyaltyCardAlreadyLinked": "This card has already been linked to an account.",
  "loyaltyCardImage": "Loyalty card image",
  "loyaltyCardMergeFailed": "We're sorry we couldn't link your card at this time. Please check if your card is already linked to another account. If not, check your connection and try again. Or, {link} for assistance.",
  "loyaltyCardValidationError": "This doesn't appear to be a valid card number. Please enter a card number that looks like ABCD-1234-EFGH.",
  "loyaltyCodeExpired": "Loyalty Code Expired",
  "loyaltyCodeExpiredDetails": "Tap the button below to generate a new one.",
  "loyaltyCreateAccountHeadline": "Welcome back to",
  "loyaltyDetailsHeroImage": "Get More Of Your Favourite Things For Free",
  "loyaltyDropdownPoints": "{points} Crowns",
  "loyaltyEarnMorePointsForReward": "Earn {points} more Crown Crowns to your next reward.",
  "loyaltyHeaderDescription": "Welcome to the new Tims Rewards",
  "loyaltyHeaderGreeting": "Hi {firstName},",
  "loyaltyHeaderPointsMessage": "You have {points} Crowns",
  "loyaltyHelp": "My Reward Level",
  "loyaltyHistorySignUp": "Sign up or Sign In to Redeem, Earn and access to your Crowns history",
  "loyaltyInfoImage": "Loyalty info image",
  "loyaltyLinkCardAlreadyUsed": "Card already used",
  "loyaltyLinkCardAlreadyUsedMessage": "This card has already been linked to an account. Please enter another card number.",
  "loyaltyLinkCardInvalidNumber": "This doesn’t appear to be a valid card number. Please enter a card number that looks like ABCD-1234-EFGH",
  "loyaltyLinkCardSuccessMessage": "You have added {points} Bonus Crowns to your account. {br}These crowns may take few minutes to appear in your account.",
  "loyaltyLinkCardSuccessTitle": "Reward Crowns Added!",
  "loyaltyNotAvailableAtThisRestaurant": "Loyalty is not available at this restaurant",
  "loyaltyOfflineNoticeBlock": "You will <Bold>only be earning crowns</Bold> when you Scan. Changes to your rewards tier and crowns may not be updated.",
  "loyaltyOnboardingAutoRedeemPointsFor": "Your Reward Level is set to:",
  "loyaltyOnboardingReceivePointsForEligiblePurchases": "Save them for when you’re ready to redeem. You can change your Rewards Level at anytime.",
  "loyaltyPoints": "You have {points} Crowns",
  "loyaltyProfileEarnCrownsBody": "Get 10 Crowns for every $1 spent on eligible purchases.",
  "loyaltyProfileEarnCrownsTitle": "Earn Crowns when you order:",
  "loyaltyProfileJoinTheProgram": "Join the program and start earning crowns and redeem rewards.",
  "loyaltyProfileMeetTheProgram": "Meet Royal Perks Rewards",
  "loyaltyProfileRedeemCrownsBody": "Redeem Crowns for your favorite BK® menu items.",
  "loyaltyProfileRedeemCrownsTitle": "Turn Crowns into free food:",
  "loyaltyProfileUnlockOffersBody": "Enjoy special promotions just for members in the App.",
  "loyaltyProfileUnlockOffersTitle": "Unlock exclusive offers:",
  "loyaltyRewards": "Loyalty Rewards",
  "loyaltyTerms": "Loyalty Terms",
  "loyaltyTimCardOfflineNoticeBlock": "Check back when you’re online to access your TimCard.",
  "loyaltyUnavailableInRegionOops": "Oops!",
  "loyaltyUnlinkCardConfirmationAction": "Deactivate Card",
  "loyaltyUnlinkCardConfirmationMessage": "When deactivating, your card can no longer be used to earn crowns neither reactivate it.",
  "loyaltyUnlinkCardConfirmationTitle": "Are you sure you want to deactivate this card?",
  "loyaltyUseMyCrowns": "Use My Crowns",
  "loyaltyUseYourPoints": "Use your crown points today.",
  "lunch": "Lunch",
  "lupin": "lupin",
  "made": "Made",
  "main": "main",
  "mainMenu": "Main menu",
  "maintainYourPoints": "Make a purchase to maintain your Crown balance",
  "makeATrueDifference": "Make a true difference",
  "makeAdditionalSelections": "Please make {quantity} selection{quantity, plural, one {} other {s}} in the \"{name}\" section to add this item to your cart.",
  "makeItYoursAgain": " - Make it Yours Again",
  "makeThisChange": "Make this change?",
  "map": "Map",
  "march": "March",
  "marketingTile": "Marketing Tile",
  "maxAttemptsReached": "You've reached the maximum login attempts we allow.",
  "maxAttemptsReachedPhoneVerify": "You've reached the maximum attempts we allow to verify your phone.",
  "maxAttemptsReachedRequestNewCode": "You've reached the maximum login attempts we allow, please request a new code below.",
  "maximumPriceError": "Your cart exceeds the maximum price for a mobile order.",
  "may": "May",
  "mayBeCookedOnSameEquipmentAs": "May be cooked on same equipment as {allergens}",
  "mayContainAllergens": "May contain: {allergens}",
  "mayContainAllergensDisclaimer": "May contain {allergens}",
  "mayContainAllergensViaSharedEquipment": "May contain via shared equipment: {allergens}",
  "maybeLater": "Maybe Later",
  "media": "Media",
  "menu": "Menu",
  "menuAcceleratorCartMessage": "Delicious & rewarding — {points} Crowns coming your way!",
  "menuAcceleratorReviewOrderMessage": "Nice pick! You're getting {points} Crowns with this order",
  "menuBackArrowAccessibilityLabel": "Go to Main Menu",
  "menuCategoryLinks": "menu-category-links",
  "menuEmptyScreenDesktopMessage": "Refresh the page, and we'll get it sizzling in no time!",
  "menuEmptyScreenMessage": "Pull to refresh, and we'll get it sizzling in no time!",
  "menuEmptyScreenTitle": "Our menu needs extra grilling",
  "menuModifierAddOption": "Add {modifierName}",
  "menuModifierRemoveOption": "Remove {modifierName}",
  "menuTileUnavailableBody": "There are no items available at this time. Please check back later.",
  "menuTileUnavailableButtonText": "Back To Menu",
  "menuTileUnavailableHeading": "Sorry No Items Found",
  "message": "Message",
  "messageAllowLocation": "Please go to settings and allow location",
  "meters": "m",
  "method": "Method: {serviceMode}",
  "migration30": "New Tims Rewards!",
  "miles": "miles",
  "milk": "milk",
  "min": "min",
  "minOrderMessage": "To redeem your offer, your cart subtotal may not be enough to cover the applied offer.",
  "minimumPointsRequired": "Minimum crowns required 50",
  "minimumPriceError": "Your cart does not meet the minimum price required.",
  "minimumPriceForCateringError": "Your cart does not meet the minimum price for a catering order.",
  "minutes": "minutes",
  "missingItems": "Wait! You're missing items",
  "mobile": "Mobile",
  "mobileOrder": "Mobile Order",
  "mobileOrderDriveThru": "Mobile Order Drive Thru",
  "mobileOrderDriveThruAt": "Mobile Order Drive Thru at",
  "mobileOrderDriveThruHours": "Mobile Order Drive Thru Hours",
  "mobileOrderDriveThruOrder": "Mobile Order Drive Thru",
  "mobileOrderDriveThruOrderPlaced": "Mobile Order Drive Thru Placed",
  "mobileOrderDriveThruPickupInstructions": "Drive up to the ordering screen and let us know you ordered online for {name}.",
  "mobileOrderDriveThruUnavailable": "Mobile Order Drive Thru is currently unavailable",
  "mobileOrderLane": "Mobile Order Drive Thru",
  "mobileOrdering": "Mobile Ordering",
  "mobileOrderingAndPaymentTerms": "Mobile Ordering and Payment Terms",
  "mobileOrderingAndPickup": "Mobile Ordering & Pickup",
  "mobileOrderingComingSoon": "Mobile Ordering Coming Soon!",
  "mobileOrderingUnavailable": "Mobile ordering is currently unavailable",
  "mobileOrderingUnavailableAtStore": "Mobile ordering is not available at this store",
  "mobilePickupVehicleDescription": "Help us find you quickly by identifying your vehicle",
  "mobilePickupVehicleDescriptionPlaceholder": "Color and make of your vehicle",
  "mobilePickupVehicleTitle": "Vehicle Description",
  "modTakeoutInstructionsText": "Let us know when you've arrived and we will bring your order to you. Otherwise, we will prepare your order at {time}",
  "modTakeoutInstructionsTextHere": "We are preparing your order. Please knock on the door to let us know you've arrived. A team member will bring your food out shortly after.",
  "modTakeoutInstructionsTextHere.th": "We have started preparing your order. Once it is ready, we will bring it out to you.",
  "modalHeading": "modal-heading",
  "mode": "Mode",
  "monday": "Monday",
  "month": "Month",
  "monthPlaceholder": "MM",
  "monthYearShort": "MM/YY",
  "more": "More",
  "moreInfo": "More info",
  "moreItems": "{remainingItems, plural, =0 {} other {{remainingItems}}} {remainingItems, plural, =0 {} one {more item…} other {more items…}}",
  "moreLeft": "more{linebreak}left",
  "moreOptions": "More Options",
  "moreOrdersToGetYouAFreeItem": "more orders to get a free item!",
  "moreYouDoTheMoreYouUnlock": "The more you do, the more you unlock. And some badges? Well, let’s just say they’re harder to get — and way more fun to flex.",
  "morning": "Morning",
  "mustAddPaymentMethod": "You must Add a Payment Method",
  "mustBeLoggedInToRedeemCoupon": "Sorry, you must be logged in {br} to redeem this coupon.",
  "mustard": "mustard",
  "myAccount": "My Account",
  "myBalance": "My Balance",
  "myCateringOrder": "My Catering Order",
  "myChallenges": "My Challenges",
  "myCode": "My Code",
  "myGiftCard": "My Tim Card",
  "myOrder": "My Order",
  "myRewards": "My Rewards",
  "myTimCardLink": "Manage Tim Card",
  "name": "Name",
  "nameOnCard": "Name on card",
  "nameOnCardIsRequired": "Name on card is required",
  "nameRequiredError": "Name is a required field.",
  "nameYourFavorite": "Name Your Favorite",
  "nativePaymentNotAvailable": "We currently don’t accept Google or Apple Pay on our websites. Please select or add a new payment method.",
  "navHome": "Home",
  "navLinkReorder": "Reorder",
  "navMenu": "Menu",
  "navMyCode": "My Code",
  "navOffers": "Offers",
  "navRewards": "Rewards",
  "nearby": "Nearby",
  "needHelp": "Need Help?",
  "needMoreHelpSendUsAMessage": "Need more help? Send us a message",
  "negativeCartError": "Your cart does not meet the minimum price required. Please add items to your cart to redeem this offer and continue.",
  "new": "New",
  "newBalance": "New Balance: ",
  "newCodeSent": "New code has been sent to your email!",
  "newCodeSentPhone": "New code has been sent to your phone number!",
  "newExclame": "New!",
  "newOffer": "New Offer",
  "newUpdateRequired": "New update required in order to continue",
  "news": "News",
  "newsAndPress": "News & Press",
  "next": "Next",
  "nextCustomize": "Next, Customize",
  "nextPage": "Next page",
  "nextReviewYourMeal": "Next, Review your Meal",
  "nextReviewYourSelection": "Next, Review Your Selection",
  "nextSelectYourDrink": "Next, Select Your Drink",
  "nextSelectYourSide": "Next, Select Your Side",
  "niceWork": "Nice work, {userName}! You have",
  "no": "No",
  "noAppDriving": "Please don't use the app while driving",
  "noAppDrving": "Please don't use the app while driving",
  "noChangesToOrderTime": "No changes to the order time can be made at this time.",
  "noCourierName": "No Name",
  "noCourierPhone": "Not Available",
  "noCurrentRewardsAvailable": "No current rewards available.",
  "noDeliveryOptionsAvailable": "Sorry, no delivery options are currently available.",
  "noDirectPayAndNoPrepaidMethodError": "We are unable to accept your payment at this time. Please try again later.",
  "noFavoritesHeader": "Favorites",
  "noFavoritesSubheader": "Favorite an item from your cart or recents to save it as a favorite.",
  "noInternetConnection": "No internet connection",
  "noItemsFitCriteria": "No items fit your search criteria",
  "noLocationsMatchYourSearch": "There are no locations that match your search.",
  "noNewOffers": "No new offers",
  "noOrderYet": "RECENT ORDERS & ITEMS WILL APPEAR HERE",
  "noOrdersItemsYet": "RECENT ORDERS & ITEMS WILL APPEAR HERE",
  "noPaymentMethodOnFile": "You currently have no payment methods on file",
  "noPaymentMethodSaved": "You currently have no stored payment methods.",
  "noPickupOptionsAvailable": "Sorry, no pickup options are currently available.",
  "noPointExpiry": "You haven’t earned any crowns yet, but don’t fret, once you do here’s where you’ll see when they expire.",
  "noRecentItemsHeader": "No Recent Items Yet",
  "noRecentItemsSubheader": "Place an order to see your recent items here.",
  "noRestaurantDeliveryCta": "Find Restaurants",
  "noRestaurantDeliveryCta.th": "Place Takeout Order",
  "noSavedPromotions": "You have no saved promotions",
  "noStoresAreOpenForDelivery": "No Stores are Open for Delivery",
  "noThankYou": "No thank you",
  "noThanks": "No thanks",
  "nonAvailableItemInStore": "This item is currently not available at your selected store.",
  "nonAvailableOfferUntil": "This coupon is not available until {time}. Please check back later!",
  "nonAvailableReward": "This reward is not available for redemption.",
  "nonAvailableRewardUntilX": "This reward is not available until {time}. Please check back later!",
  "nonRedeemableOffer": "Uh oh, offer cannot be applied",
  "nonTraditionalStoreDrawerHeader": "This is a special location",
  "noneFound": "None Found",
  "notARoyalPerksMember": "Not a Royal Perks Member?",
  "notApplicable": "N/A",
  "notAvailableAtStore": "Not available at selected store",
  "notEnoughPoints": "You do not have enough crowns",
  "notNow": "Not Now",
  "notSelected": "Not selected",
  "notValidEmailError": "That doesn't look like a valid email.",
  "notValidEmailOrPhoneNumberError": "That doesn't look like a valid email or phone number",
  "notValidNameError": "That doesn't look like a valid name.",
  "notValidPhoneNumberError": "That doesn't look like a valid phone number",
  "notValidPhoneNumberPatternError": "Not a valid phone number format ex: 888-888-8888",
  "notValidRewardsErrorBody": "The barcode you scanned doesn't look like a Rewards card. Try a different barcode?",
  "notValidRewardsErrorHeading": "That doesn't look like a Rewards Card.",
  "nothingInCart": "You dont have anything in your cart yet",
  "notifications": "Notifications",
  "notifyDescription": "Adjust the types of communication you receive from us, and how:",
  "november": "November",
  "now": "Now",
  "numberOfCrowns": "{crowns} crown{crowns, plural, one {} other {s}}",
  "nutritionCommitment": "At Burger King, we're committed to serving our Guests great-tasting food made with quality ingredients. Our iconic Whopper sandwiches—crafted with flame-grilled, 100% real beef and freshly cut toppings—are a proud example of that promise. As the Home of Have It Your Way, we're continually innovating to create delicious recipes using ingredients our Guests can trust.",
  "nutritionDisclaimer": "The nutrition information presented on this website is based on standard product formulations and was obtained through analysis by our nutritional software, entitled ESHA Genesis R&D, and information provided by our suppliers. Variations may occur due to differences in suppliers, ingredient substitutions, recipe revisions, assembly at restaurant level, and/or season of the year. Regional variations may occur. Certain menu items may vary from restaurant to restaurant and may not be available at all locations. Baked goods may vary in size. This information includes a selection of Tim Hortons’ most popular items and may not include all items found in-restaurant. Information is applicable to products in Canadian restaurants and may be subject to change at any time. Please check this website periodically for updates. Nutrition information for non-customized products follows government regulations for the rounding of nutrition data.",
  "nutritionInfoDownloadPDF": "Download Nutrition Info",
  "nutritionalInformation": "Nutritional Information",
  "nutritionalInformationAndAllergen": "Nutritional, Allergen and Ingredient Information",
  "nycRestaurantHealthRatings": "NYC Restaurant Health Ratings",
  "october": "October",
  "of": "of",
  "offer": "Offer",
  "offerActivationError": "Error activating offer. Please try again.",
  "offerActivationSuccess": "Offer Activated!",
  "offerAddedToCart": "Offer added to cart",
  "offerApplied": "Offer Applied",
  "offerAppliedSuccess": "Offer has been removed from your order",
  "offerConfirmDialogBody": "Closing this screen will mark this coupon as redeemed. Are you sure?",
  "offerConfirmDialogConfirmLabel": "Continue",
  "offerConfirmDialogHeading": "All Finished?",
  "offerExpires": "Expires {date}",
  "offerExpiresDays": "{days} days left",
  "offerExpiresHours": "{hours} hours left",
  "offerFeedbackDefault": "Your cart does not meet the requirements to redeem this {incentiveType}",
  "offerFeedbackSubtotal": "Your subtotal must be {targetValue} to redeem this {incentiveType}. Add ${calculatedValue} to redeem",
  "offerGroupBadgeLabel": "Offer Group",
  "offerNotApplied": "Offer not applied",
  "offerNotAvailable": "Offer not available",
  "offerNotAvailableForMobileRedemption": "Online redemption is not available for this offer",
  "offerNotAvailableInRestaurantPos": "An item in your offer is not available at this restaurant.",
  "offerPicture": "Offer Picture",
  "offerRedeemableAgainIn": "You can redeem this offer again {redeemableIn}.",
  "offerRedeemableIn": "You can redeem this offer {redeemableIn}.",
  "offerRedeemableOn": "You can redeem this offer on {redeemableOn}.",
  "offerRequirements": "The offers in your cart have requirements that have not been met yet. Click \"Try Again\" to go back to the menu and add the required items to your cart.",
  "offerSelected": "Offer Selected",
  "offerTerms": "Offer Terms",
  "offerUnavailableForDelivery": "This offer is unavailable for Delivery",
  "offerUnavailableForPickup": "This offer is unavailable for Pickup",
  "offerUpsellDiscard": "No, Thanks",
  "offerUpsellTitle": "Hungry For More?",
  "offers": "Offers",
  "offersAddedToCart": "Offers Added to Cart",
  "offersAreCurrentlyNotAvailable": "Your offers are on their way.",
  "offersAvailableAt": "Redeem again at {time}",
  "offersAvailableAtFallback": "One more hour and you can redeem more.",
  "offersCooldownDescription": "Offers will become available again in {minutes} minutes.",
  "offersCooldownDescriptionFallback": "Offers will become available again soon.",
  "offersCooldownInfo": "Limit one offer per visit. All other offers become unavailable for {period} minutes.",
  "offersCooldownTitle": "You just redeemed an offer",
  "offersDisclaimer": "One per customer. No substitutions. Non valid on delivery or with other coupons or offers. Available at participating US Popeyes® locations (except AK & HI). Void where prohibited or if reproduced, altered or transferred. Tax may apply. Cash value at 1/100¢. TM & © 2021 PLKI. All rights Reserved. Expires {deactivationDate}",
  "offersEmptyStateText": "There's currently no offers available. Check back later for offers and updates.",
  "offersNoLocationSelected": "No Location Selected",
  "offersNoOffersAvailable": "No Offers Available",
  "offersNotAvailableOnCatering": "We don't have offers available for catering at this time.",
  "offersNotAvailableOnDelivery": "We have a number of Delivery offers getting ready just for you! Check back soon for updates",
  "offersNotAvailableOnDeliveryChangeOrderType": "Change your order to pickup to see available offers.",
  "offersNotAvailableOnDeliveryChangeServiceMode": "Your cart includes an offer that is not currently available for delivery orders. If you’d like to place a delivery order press continue and we’ll remove the offer from your cart.",
  "offersNotAvailableOnDeliveryChangeServiceModeContinue": "Continue to delivery",
  "offersSelectStore": "Select a Store",
  "offersSelectStoreToViewOffers": "Select a store to view available offers.",
  "offersYouCanStillEnjoyYourFavorites": "You can still enjoy your favorites by ordering from the menu.",
  "ok": "Ok",
  "okay": "Okay",
  "okayButtonText": "Okay",
  "oneCouponPerOrder": "Only one coupon per order",
  "oneDollarEqualsTenCrowns": "$1 = 10 Crowns",
  "oneMoment": "One Moment",
  "oneOfferPerOrder": "Only one offer per order",
  "onlineSoon": "Online Soon",
  "only": "only",
  "oopsComeBackTomorrow": "Oops! Come back tomorrow at {storeTime} or select another store.",
  "oopsSomethingWentWrong": "Oops Something Went Wrong",
  "open": "Open",
  "open24Hours": "Open 24 hours",
  "openDeviceSettings": "Go to Settings",
  "openStoreDiagnosticModal": "Open a diagnostic modal for this store",
  "opensAt": "Opens at {time}",
  "opportunities": "Opportunities",
  "option": "option",
  "optional100PercentGoesToDriver": "optional, 100% goes to driver",
  "optionalInformation": "Optional Information",
  "options": "options",
  "optionsLoaded": "Options have loaded.",
  "or": "or",
  "orAddNew": "or Add New",
  "orScanForKiosk": "Or Scan at the Kiosk",
  "order": "Order",
  "orderAccepted": "Order Accepted!",
  "orderAtThisStore": "Order at {storeLabel} store",
  "orderBay": "Order Bay",
  "orderBayOrder": "Order Bay Order",
  "orderBayOrderPlaced": "Order Bay Order Placed",
  "orderCancelled": "Order Cancelled",
  "orderCannotBeRefundedMessage": "Seems like there was an error issuing your refund. Please {link} to report your issue. If you have already requested a refund, please allow 3-5 business days for the amount to reflect in your account.",
  "orderCompleted": "Order Completed!",
  "orderConfirmation": "Order Confirmation",
  "orderConfirmationInstructionsConfirmed": "Come in and head to the Pick Up area at the counter to check in with a Team Member. Then find a seat to enjoy!",
  "orderConfirmationInstructionsConfirmedCurbside": "We have started preparing your order. Please park in a designated curbside parking spot and we will bring your order to your vehicle.",
  "orderConfirmationInstructionsConfirmedOrderBay": "Stay tuned to the Menu screen for updates on when your order is ready. Drive up to the pick up window when prompted.",
  "orderConfirmationInstructionsDelivery": "We are preparing order and it will be delivered to your address when ready.",
  "orderConfirmationInstructionsDriveThru": "Drive up to the ordering screen and let us know you ordered online for {userName}.",
  "orderConfirmationInstructionsMobileDriveThru": "Drive up to our dedicated Mobile Order Lane and we'll walk your order out to your car.",
  "orderConfirmationInstructionsPreConfirmed": "Tap {imHere} when you arrive so we can prepare your order. Your card won’t be charged until then.",
  "orderConfirmationInstructionsTakeOut": "Head to the Pick Up area at the counter to check in with a Team Member.",
  "orderConfirmationNumber": "Order #{orderNumber}",
  "orderConfirmedHeading": "Order Confirmed",
  "orderCreated": "Order Created",
  "orderDate": "Order Date",
  "orderDeclined": "Order Declined!",
  "orderDelivery": "Order Delivery",
  "orderDeliveryMinimumHeading": "Order Under Minimum",
  "orderDetailsHeading": "Order Details",
  "orderFailureMessage": "We encountered an error creating your order. We are aware of the issue and are working to resolve it. Please try again or contact {link}",
  "orderFailureMessageForApplePay": "Your payment with Apple Pay failed. Your card will not be charged and any pending transaction are typically released in 24-48 hours.",
  "orderFailureMessageForGooglePay": "Your payment with Google Pay failed. Your card will not be charged and any pending transaction are typically released in 24-48 hours.",
  "orderHasBeenRefundedMessage": "Your refund is being processed. You will receive an email once your refund has been completed.",
  "orderHasBeenSaved": "{userName}, your order has been saved.",
  "orderHere": "Order Here",
  "orderHereAccessibilityLabel": "Order at this location",
  "orderHistory": "Order History",
  "orderInProgress": "Order in progress",
  "orderInRestaurant": "Order In-Restaurant",
  "orderIsBeingMadeYourWay": "{userName}, your order is being made your way!",
  "orderLimitHeading": "Order Limit Reached",
  "orderLimitMessage": "Looks like you are going to exceed our {maxLimit} order amount limit. Remove an item or 2 if you'd like to add this to your order.",
  "orderLimitWarningX": "Order can not exceed {limit}",
  "orderMinimumMessage": "Looks like you are under the {minLimit} order minimum. Add more items if you'd like to complete your order.",
  "orderMinimumWarningX": "Order must be over {min}",
  "orderMissingItemscontent": "Please click back and select \"Order Never Arrived\" if your order is completely missing.",
  "orderMissingItemsheading": "Issue with my item(s)",
  "orderMissingItemssubheading": "Confirm all the following items are missing.",
  "orderName": "Order Name",
  "orderNeverArrived": "Order Never Arrived",
  "orderNeverArrivedcontent": "Please click back and select \"Issue with my item(s)\" if your order is only partially missing.",
  "orderNeverArrivedheading": "Order Never Arrived",
  "orderNeverArrivedsubheading": "Confirm all the following items are missing.",
  "orderNotCompleted": "Your order could not be completed",
  "orderNow": "Order Now",
  "orderNowWithRewards": "Order now with rewards",
  "orderNumber": "Order number",
  "orderPayment": "Order Payment",
  "orderPickup": "Order Pickup",
  "orderPlaced": "Order Placed",
  "orderPlacedAt": "Order placed at",
  "orderPlacedBy": "Order placed by",
  "orderPrepared": "Order Prepared",
  "orderProcessingDisclaimer": "We won't start preparing your order and your card will not be charged until you press \"I'm Here\" on the next screen.",
  "orderProcessingDisclaimerCashPayment": "We won't start preparing your order until you press \"I'm Here\" on the next screen.",
  "orderProcessingDisclaimerImClose": "We won't start preparing your order and your card will not be charged until you press \"I'm Close\" on the next screen.",
  "orderProcessingDisclaimerImCloseCashPayment": "We won't start preparing your order until you press \"I'm Close\" on the next screen.",
  "orderRedemptionOrderType": "Offer Redemption: Select Order Type",
  "orderTime": "Order time",
  "orderWillBeReadyName": "Your order will be ready soon, {name}",
  "orderXWillBeReadyAtY": "Order {orderNumber} Will{linebreak} Be Ready At {readyAtTime}",
  "orderXWillBeReadySoon": "Order {orderNumber} Will{linebreak} Be Ready Soon",
  "orderingFrom": "Ordering from",
  "orderingIssues": "Ordering Issues?",
  "orderingOptions": "Ordering Options",
  "ordersMustBePlaced24HrsAhead": "!Orders must be placed 24 hrs ahead",
  "ordersMustBePlacedHrsAhead": "Orders must be placed {hrs} hrs ahead!",
  "otaDownloadAndRestart": "Download and restart",
  "otaDownloading": "Downloading…",
  "otaNotNow": "Not now",
  "otaUpdateAvailable": "Update available",
  "otaUpdateAvailableDescription": "There is an important update available. Would you like to download and apply the update now?",
  "otaUpdateRequired": "Update required",
  "otaUpdateRequiredDescription": "There is a crucial update that must be applied to ensure this application continues to work properly.",
  "other": "Other",
  "otherDiscounts": "Other Discounts",
  "others": "Others",
  "otpFormHeadline": "Unlock exclusive offers, rewards & experiences",
  "ourMenu": "Our Menu",
  "ourOffers": "Our Offers",
  "ourRestaurantsNearYou": "Our restaurants near you",
  "outForDelivery": "Out for Delivery",
  "outOfDayparts": "{dayParts} only",
  "outOfRangeHeading": "You're out of range",
  "outOfRangeMessage": "Unfortunately we cannot currently deliver to this address. Enter your email below to receive updates on availability in your area.",
  "outOfRangeMessageAuthenticated": "Unfortunately we cannot currently deliver to this address. Would you like to see wings availability at Popeyes?",
  "outOfRangeSuccessMessage": "Thank you for submitting your email. Would you like to see wings available at Popeyes?",
  "outdatedCartVersionMessage": "Hey, good news! We updated our experience. Sadly, any old items in your cart had to be cleared.",
  "pageChangedReaderCarousel": "Displaying items {firstItemSlide} to {lastItemSlide} of {totalCards}",
  "pageMoved": "The page you were looking for was moved or doesn't exist",
  "pageNotFound": "Page Not Found",
  "partnerOffers": "Partner Offers",
  "partnershipWalmartDescription": "25% off for 1 order daily + Free Whopper® with purchase every 3 months.",
  "partnershipWalmartTitle": "BK & Walmart+",
  "partnerships": "Partnerships",
  "payEarnReward": "Pay, Earn & Redeem",
  "payWith": "Pay with",
  "payWithCash": "Pay With Cash",
  "payWithEase": "Pay with ease using your code.",
  "payWithMyPrepaidCard": "Pay with my {cardAlias} Card",
  "payWithPayPal": "Pay with PayPal",
  "payWithVenmo": "Pay with Venmo",
  "payWithYour": "Pay with your",
  "payment": "Payment",
  "paymentAddingError": "Credit card details may be incorrect or we are experiencing issues with your card, please try again or check with your bank.",
  "paymentDeclined": "We won’t be able to complete this transaction. Check with your card provider for details.",
  "paymentDeclinedDisclaimer": "Your order remains in the cart, you can go back to try again",
  "paymentDeclinedHeading": "Oops. Looks like something went wrong.",
  "paymentDeletingError": "There was an error deleting your payment method.",
  "paymentDetails": "Payment Details",
  "paymentDetailsError": "Something went wrong with your payment information. Please try again or contact support {link}.",
  "paymentDetailsErrorHeading": "Payment Error",
  "paymentFailed": "Your payment failed to go through.",
  "paymentLoadingError": "There was an error loading your payment method.",
  "paymentMethod": "Payment Method",
  "paymentMethodAdded": "A new payment method was added.",
  "paymentMethodNotAvailable": "Not available",
  "paymentMethods": "Payment Methods",
  "paymentNotSupported": "Please try selecting another payment method.",
  "paymentNotSupportedHeading": "Oops. This restaurant is currently unable to accept your payment method.",
  "paymentProcessingError": "There was a problem processing your payment. Try again?",
  "paymentVerification": "Payment Verification",
  "paymentXEndingInY": "{cardType} ending in {ccLast4}",
  "paypal": "PayPal",
  "peanuts": "peanuts",
  "people": "People",
  "perOneHundredGOrMl": "Per 100g or 100ml",
  "perServing": "Per serving",
  "perks": "Crowns",
  "perksReadyToUse": "Your Perks are Ready to Use",
  "personalMessageToRecipient": "Personal message to the recipient.",
  "personalized": "Personalized",
  "phoneAppStoresDisclaimers": "Apple and the Apple logo are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc. Google Play is a trademark of Google Inc. Terms apply.",
  "phoneNumber": "Phone Number",
  "phoneNumberDisclaimer": "The phone number on file will be used by drivers to get in touch with you. By continuing, you agree to share your contact information with the DoorDash or Postmates drivers that will deliver your food.",
  "phoneNumberError": "Please enter a valid phone number.",
  "phoneNumberInputDrawerSubtitle": "You are one step closer to an ultimate royal treatment!",
  "phoneNumberInputDrawerTitle": "Add Your Phone Number",
  "phoneNumberPlaceholder": "+13050000000",
  "phoneNumberRequired": "Phone Number (Required)",
  "phoneNumberRequiredError": "Phone number is a required field.",
  "phoneNumberTooLongError": "Phone number inserted is too long.",
  "phoneNumberTooShortError": "Phone number inserted is too short.",
  "phoneNumberUpdatedSuccess": "Your phone number has been updated!",
  "phoneNumberWillBeSaved": "Phone number will be saved to your account.",
  "pickALabel": "Pick a Label (Required)",
  "pickUp": "Pick Up",
  "pickUpAt": "Pick up at",
  "pickUpAtSelectALocation": "Pick up at: select a location",
  "pickUpBefore": "<pickup>Pick up</pickup> before {pickupTime}",
  "pickUpBeforeDayPart": "<pickup>Pick up</pickup> before {dayPartEndTime}",
  "pickUpConfirmationScreenReaderInstructions": "Your order has been saved! Before arriving at the store, please press the \"{screenReaderButtonName}\" button on this page so that our team members know when to start preparing your order.",
  "pickUpOnly": "Pick up only",
  "pickUpOrder": "Pick Up Order",
  "pickUpOrderAt": "I'll pick up my order at...",
  "pickUpOrderIn": "We'll start preparing your order in...",
  "pickUpOrderPlaced": "Take Out Order Placed",
  "pickUpOrderRestaurantClosing": "Store is not accepting digital orders at this time",
  "pickUpOrderSuccessfulAlert": "Your order has been successful, enjoy your order. Your order number is {orderNumber} in the {brand} at {address}.",
  "pickUpTime": "Pick up time",
  "pickUpUnavailable": "Pick Up is currently unavailable",
  "pickupComingSoon": "Pickup COMING SOON",
  "pickupDateTime": "{date}{linebreak}{time}",
  "pickupDetailsBackButton": "Back",
  "pickupDetailsHeading": "When will you pick up your order?",
  "pickupDetailsNextButton": "Next",
  "pickupDetailsSubheading": "Please order 72 hours in advance. If your order will be $1500 or more, please contact the restaurant directly.",
  "pickupInstructions": "Come inside the restaurant or drive into our drive thru and let us know you placed a mobile order for {name}.",
  "pickupModeContentHeading": "Order Now",
  "pickupModeCurbsideContent": "Swing by and we’ll bring your order to your vehicle.",
  "pickupModeCurbsideHeading": "Curbside",
  "pickupModeDineInContent": "Dine-in and enjoy your order in the restaurant",
  "pickupModeDineInHeading": "Dine-In",
  "pickupModeDriveThruContent": "Drive-thru and let us know you have a mobile order.",
  "pickupModeDriveThruHeading": "Drive-Thru",
  "pickupModeTakeoutContent": "Pick up and take your order to go.",
  "pickupModeTakeoutHeading": "Take-Out",
  "pickupNowEta": "Ready in 5-7 minutes",
  "pickupTime": "Pickup Time",
  "pickupUnavailable": "Pickup - Unavailable",
  "pickupWindow": "Closing in {minutes} min — please pickup as soon as possible!",
  "pin": "PIN",
  "placeAnOrderToEarn": "Place an order to earn",
  "placeOrder": "Place Order",
  "placeOrderDescription": "Place {serviceMode} order for {price}",
  "placeSecureOrder": "{secureOrderIcon} Place Secure Order",
  "placingOrder": "We are sending you order to the store.",
  "placingOrderCheckoutBtn": "Placing Order",
  "platformOnly": "{platform} only",
  "playNow": "Play Now",
  "pleaseCheckBackNextWeek": "Sit tight and check back again soon for more delicious deals.",
  "pleaseConfirmYourCreditCardInformation": "Please confirm your credit card details",
  "pleaseEnterYourCreditCardInformation": "Please enter your credit card information",
  "pleaseGoToTheFrontCounterToScanRewards": "Please go to the front counter to scan rewards",
  "pleaseHaveYourCashReady": "Please have your cash ready",
  "pleaseHeadToTheCounterToPayForYourOrder": "Please head to the counter to pay for your order",
  "pleaseMakeSelectionInXHours": "Please make your selection within {hour} hours.",
  "pleaseOrder24InAdvance": "Please order 24 hours in advance",
  "pleasePayForYourOrderUsingTheTerminal": "Please pay for your order using the terminal",
  "pleaseProvideAValid16Digit": "Please enter a valid 16-digit card number.",
  "pleaseProvideTheCardName": "Please enter the name on the card.",
  "pleaseProvideTheCreditCardCvv": "Please enter the CVV.",
  "pleaseProvideTheExpirationDate": "Please enter the expiration date.",
  "pleaseProvideTheZipCode": "Please enter the zip code.",
  "pleaseProvideYourPhoneNumberForTheOrder": "Please provide your phone number for the order",
  "pleaseReAuthenticateToContinue": "Please re-authenticate to continue. You will be signed out momentarily for security purposes.",
  "pleaseSelect": "Please select",
  "pleaseSelectAPaymentOption": "Please select a payment option",
  "pleaseSelectOne": "Please select one",
  "pleaseTryAgainLater": "Please try again later.",
  "pleaseTryToRefresh": "Please try to refresh.",
  "pleaseVerifyEmail": "Please verify your email.",
  "pleaseVerifyYourPhoneNumber": "Please verify your phone number",
  "plk.pypestreamLoadingMessage": "Your support experience is marinating.",
  "plkLogoTitle": "Popeyes",
  "plkPointsApplied": "Applied",
  "plkPointsEarned": "{points} Crown{points, plural, one {} other {s}} Earned",
  "plkRewards": "Popeyes Rewards",
  "plk_logo_title": "Popeyes Logo",
  "pluralDays": "Day{days, plural, one {} other {s}}",
  "pluralHours": "Hour{hours, plural, one {} other {s}}",
  "pluralMins": "Min{minutes, plural, one {} other {s}}",
  "points": "Crowns",
  "pointsApplied": "Crowns Applied",
  "pointsEarned": "{pointsEarned, plural, one {You've earned {pointsEarned} Crown!} other {You've earned {pointsEarned} Crowns!}}",
  "pointsEarnedLabel": "Crown{points, plural, one {} other {s}} Earned",
  "pointsExpireMonthly": "Crowns expire at the end of each month.",
  "pointsExpired": "Crown{points, plural, one {} other {s}} Expired",
  "pointsNumber": "{points} pts",
  "pointsRedeemed": "Crown{points, plural, one {} other {s}} Redeemed",
  "pointsUsed": "Crown{points, plural, one {} other {s}} Used",
  "policies": "Policies",
  "popeyesCatering": "Popeyes Catering",
  "popeyesFoundation": "The Popeyes Foundation",
  "popeyesRewards": "Popeyes Rewards",
  "postalCode": "Postal Code",
  "postalCodeInvalid": "Postal Code Invalid",
  "postalCodeRequiredError": "Postal Code Required",
  "poweredByThirdPartyDeliveryProviders": "Powered by Third-Party Delivery Providers",
  "preferences": "Preferences",
  "premiumOptions": "Premium options",
  "preorder": "Pre-order: {serviceMode}",
  "prepDeliveryTime": "Prep & Scheduled Time",
  "prepPickUpTime": "Prep & Pick Up Time",
  "prepaidAccountAlreadyExistsError": "A new Tim Card could not be created since your account already has a Tim Card",
  "prepaidCardBalance": "{cardAlias} Card Balance",
  "prepareIn10MinLabel": "Start preparing my order in ten minutes",
  "prepareIn15MinLabel": "Start preparing my order in fifteen minutes",
  "prepareIn20MinLabel": "Start preparing my order in twenty minutes",
  "prepareIn30MinLabel": "Start preparing my order in thirty minutes",
  "prepareIn45MinLabel": "Start preparing my order in forty five minutes",
  "prepareIn5MinLabel": "Start preparing my order in five minutes",
  "prepareIn60MinLabel": "Start preparing my order in 1 hour",
  "prepareInMinLabel": "Start preparing my order in {minutes} minutes",
  "prepareNow": "Prepare Now",
  "prepareNowLabel": "Start preparing my order now",
  "preparedOnEquipment": "Prepared on equipment used for products that contain {preparedOnEquipmentAllergens}.",
  "preparedToOrder": "Prepared to Order",
  "presentQRCodeToEarnPoints": "Present this QR code to the cashier before payment to earn crowns on your order.",
  "pressOkToEnableCameraPermissions": "Press Ok to enable camera permissions in app settings",
  "previous": "Previous",
  "previousPage": "Previous page",
  "price": "Price: {price}",
  "priceMismatchDetected": "Price Mismatch Detected",
  "pricedAndAvailableError": "We ran into a temporary technical issue processing your order. Please try again.",
  "pricesDiscountsAndAvailabilityAreSbujectToChangeWhenYouReorder": "Prices, discounts and availability are subject to change when you reorder.",
  "primaryNavLinks": "Primary Navigation",
  "privacy": "Privacy",
  "privacyPolicy": "Privacy Policy",
  "prizes": "Prizes",
  "problemsDetected": "Problems Detected",
  "product": "Product",
  "productChallengedCompleted": "Challenge Completed",
  "productDetailChooseModifier": "Choose a modifier option for {modifierName}",
  "productDetailCloseContent": "Do you want to leave without finishing?",
  "productDetailCloseHeading": "Leaving Now",
  "productDetailCurrentSelectionX": "Current selection {selection}",
  "productDetailEditModifier": "Edit modifier",
  "productDetailGoBack": "Go back to {screen}",
  "productDetailPickerCustomizationGoBack": "Go back to {screen} customization",
  "productDetailPickerGoBack": "Go back to {screen} product details",
  "productDetailResetContent": "Selecting a new option will cause previous customizations to be lost.",
  "productDetailResetHeading": "Reset Customizations",
  "productDetailSummaryCustomizableTitle": "Customize Your Order",
  "productDetailSummaryTitle": "Your Order",
  "productInformation": "Product Information",
  "profile": "Profile",
  "profileCompletionStarted": "Profile Completion started!",
  "profileCompletionUpdated": "Profile Completion Updated!",
  "progressbar": "progressbar",
  "promoCodeAddedToOffers": "Promo Code added to Offers",
  "promoCodeApplied": "Promo code applied successfully! Check the {page} section on the home page",
  "promoCodeAppliedPage": "Rewards & Offers",
  "promoCodeBadgeLabel": "Promo Code",
  "promoCodeBodyDetails": "Please enter the 12 digit promo code below",
  "promoCodeCTA": "Have a Promo Code?",
  "promoCodeCartRedeemedCode": "Promo code has already been used or is saved to your promo codes. Click on the link below to view saved promotions.",
  "promoCodeLabel": "Enter promo code",
  "promoCodeOfferExpiredCode": "The code you entered has expired",
  "promoCodeOfferInvalidCode": "Invalid Promo Code Entered",
  "promoCodeOfferInvalidOfferId": "The code you entered is not valid for this offer",
  "promoCodeOfferRedeemedCode": "The code you entered has already been redeemed",
  "promoCodeOfferRequired": "Promo code required to unlock offer",
  "promoCodeOfferUnknownException": "Something went wrong. Please try again.",
  "promoCodeSubmitBtnText": "Submit Code",
  "promotionEnded": "The promotional period has ended",
  "proteins": "Proteins",
  "provideBeforeOrderingAtStore": "Provide code before ordering.",
  "providedBy": "Provided by",
  "province": "Province",
  "pspPaymentDeclinedMessage": "Hi {name}, your transaction was declined. Contact your card issuer for assistance.",
  "pspPaymentDeclinedTitle": "Declined",
  "pspPaymentDeclinedTransactionForterMessage": "Hi {name}, your transaction was declined.  Try a different payment method.",
  "pspPaymentDeclinedTransactionForterTitle": "Declined Transaction",
  "pspPaymentDeclinedTransactionMessage": "Hi {name}, your payment exceeded the daily approval limit. Contact your card issuer or select a different payment method.",
  "pspPaymentDeclinedTransactionTitle": "Declined Transaction",
  "pspPaymentExpiredCardMessage": "Hi {name}, your card appears to be expired. Double-check the date and try again.",
  "pspPaymentExpiredCardTitle": "Expired Card",
  "pspPaymentIncorrectInformationMessage": "Hi {name}, the card information you entered is incorrect. Check your details and try again.",
  "pspPaymentIncorrectInformationTitle": "Incorrect Card Information",
  "pspPaymentInsufficientFundsMessage": "Hi {name}, there was an issue processing your payment. Check your account balance or try using a different payment method.",
  "pspPaymentInsufficientFundsTitle": "Insufficient Funds",
  "pspPaymentInvalidCardMessage": "Hi {name}, the card number you entered is invalid. Check your details and try again.",
  "pspPaymentInvalidCardTitle": "Invalid Card",
  "pspPaymentRestrictedCardMessage": "Hi {name}, your card is restricted from making this transaction. Try a different payment method or contact your card issuer for more information.",
  "pspPaymentRestrictedCardTitle": "Restricted Card",
  "pspPaymentStoreErrorMessage": "Hi {name}, this store is not accepting payments right now. Please try another store.",
  "pspPaymentStoreErrorTitle": "Store Error",
  "pspPaymentUnableToProcessMessage": "Hi {name}, there’s a problem with your payment. Get in touch with your card issuer or select another payment option.",
  "pspPaymentUnableToProcessTitle": "Unable to Process",
  "pts": "{points}pts",
  "pullToRefresh": "Pull down further to refresh",
  "purchaseAdded": "This purchase was added to your visit count",
  "purchaseAmount": "Amount",
  "purchaseDidNotCountTowardsReward": "This purchase did not count toward your next reward. Please see {link} to learn more.",
  "purchaseSevenTimes": "Purchase 7 times",
  "push": "Push",
  "pushNotifications": "Push Notifications",
  "putThisCodeUnderTheScanner": "Scan to earn crowns and use rewards",
  "pypestreamWelcomeAnon": "Hey there! I'm the {brand} digital assistant, here to help resolve any order issues and answer your questions.  One moment while we look you up.",
  "pypestreamWelcomeUser": "Hey {name}! I'm the {brand} digital assistant, here to help resolve any order issues and answer your questions. One moment while we pull up your order history.",
  "qrScannerUnavailable": "QR Scanner unavailable. Please try updating to the latest app version.",
  "qty": "Qty: ",
  "quantity": "Quantity",
  "quantityAriaLabel": "Quantity {productQuantity} of {productName}",
  "quantityItemInYourCart": "{quantity} {itemName} in your cart",
  "quantityOf": "Quantity of {name}",
  "quantityUpdatedAlert": "You now have {quantity} {itemName} in your cart.",
  "quest": "Quest",
  "questBonusPointsRedeemedDescription": "Your crowns have been added to your profile!",
  "questCheckNetworkText": "Please check your internet connection and try again",
  "questCompletedDescription": "Congratulations on completing this quest!",
  "questCompletedDescriptionPlk": "Congratulations on completing this Challenge!",
  "questLoadError": "Sorry we couldn't load the {quest}",
  "questRewardRedeemedDescription": "You already redeemed your reward!",
  "questTerms": "{quest} Terms",
  "question": "Question",
  "questionsAboutOrder": "Have any questions about your order?",
  "quests": "Quests",
  "quickNote": "Quick note",
  "quickPay": "Quick Pay",
  "readLess": "Read Less",
  "readMore": "Read More",
  "receipt": "Receipt",
  "recent": "Recent",
  "recentHistory": "Recent History",
  "recentItems": "Recent Items",
  "recentItemsFailed": "Oops! Recent Items failed to load",
  "recentOrders": "Recent Orders",
  "recentOrdersDisclaimer": "Prices, discounts and availability are subject to change when you reorder.",
  "recentOrdersEmptySubHeader": "Go start a new order now!",
  "recents": "Recents",
  "recipientsEmail": "Recipient's Email",
  "recyclingFee": "Recycling Fee",
  "redeem": "Redeem",
  "redeemACoupon": "Redeem a coupon",
  "redeemApply": "Use {points}",
  "redeemAtRestaurant": "Use at restaurant",
  "redeemFreeBK": "Redeem Free BK",
  "redeemInNext": "Redeem in the next",
  "redeemInRestaurant": "Redeem in Restaurant",
  "redeemInRestaurantShortCodeInstruction": "Give this code to the cashier when you order to get the offer and earn crowns",
  "redeemMyPoints": "Redeem my Crowns",
  "redeemNow": "Redeem Now",
  "redeemOfferConfirmation": "To redeem your offer, your cart subtotal must be equal to or greater than offer value. If you choose to continue, we'll remove the offer from the order.",
  "redeemOffers": "Redeem Offers",
  "redeemPointsDisclaimer": "Your Crowns will only be used to redeem selected items",
  "redeemPointsForRewards": "Redeem Crowns for Rewards",
  "redeemQuestReward": "Redeem Reward",
  "redeemRemove": "Remove {points}",
  "redeemReward": "Redeem your reward",
  "redeemRewards": "Redeem Rewards",
  "redeemTab": "Redeem",
  "redeemThisCoupon": "redeem this coupon",
  "redeemedRewards": "{redeemedRewards, plural, one {You've redeemed {redeemedRewards} reward.} other {You've redeemed {redeemedRewards} rewards.}}",
  "redeeming": "Redeeming",
  "redemptionCode": "Redemption code",
  "refresh": "Refresh",
  "refreshCodeTextExpired": "Refresh to generate a new one.",
  "refreshCodeTitleExpired": "Refresh this page to continue",
  "refreshOffers": "Refresh my offers",
  "refreshPlease": "Refresh",
  "refundClickHere": "click here",
  "refundEligibilityInfo": "Orders are eligible for partial or full refunds. Select from your orders below to submit for a refund.",
  "refundNetworkError": "Seems like there was an error issuing your refund. Please {link}, to report your issue. If you have already requested a refund, please allow 3-5 business days for the amount to reflect in your account.",
  "register": "Register",
  "registerCardDescription": "Enter the digits on the back of the card to protect your balance, continue earning and track your rewards. Your previous transactions and rewards will be added to your account.",
  "registerYourPhysicalCard": "Link Physical Rewards Card",
  "regular": "Regular",
  "releaseToRefresh": "Release to refresh!",
  "reload": "Reload",
  "reloadAndContinue": "Reload {amount} and continue",
  "reloadAndPlaceOrder": "Reload {amount} and place order",
  "reloadCard": "Reload Card",
  "reloadCardError": "There was an error loading your Tim Card.",
  "reloadCardWithAmount": "Reload {amount}",
  "reloadCrownCardCardError": "There was an error loading your BK Crown Card.",
  "reloadExplanation": "Your current BK Crown Card balance won't cover the cost of today's order. When you place your order we'll load {reloadAmount} on your Crown Card.",
  "reloadExplanation.bk": "Your current BK Crown Card balance won't cover the cost of today's order. When you place your order we'll load {reloadAmount} on your Crown Card.",
  "reloadExplanation.plk": "Your current Popeyes Gift Card balance won't cover the cost of today's order. When you place your order we'll load {reloadAmount} on your Gift Card.",
  "reloadExplanation.th": "Your current TimCard balance won't cover the cost of today's order. When you place your order we'll load {reloadAmount} on your TimCard.",
  "reloadMethods": "Reload Methods",
  "reloadNow": "Reload now",
  "reloadYourBalance": "Reload your balance",
  "reloadYourCard": "Reload Your Card",
  "remaining": "{hoursAndMinutes} Remaining",
  "remainingTags": "{remainingTags, plural, one {filter} other {filters}}",
  "rememberToMakeAPaymentDelivery": "Remember to make a payment upon delivery of your order",
  "rememberToMakeAPaymentPickup": "Remember to make a payment upon picking up your order ",
  "remove": "Remove",
  "removeAddressBody": "Are you sure you want to remove it from your saved addresses? This action can't be undone.",
  "removeAddressHeading": "Delete this address?",
  "removeAppliedCartPromoCodeAriaLabel": "Click here to remove current promotion from cart",
  "removeCustomizations": "This will remove any customizations you had previously made to this {itemType}.",
  "removeExpiredOfferItem": "We removed items in your cart that are no longer available at this time.",
  "removeFavorite": "Remove from Favorites?",
  "removeFavoriteConfirm": "Are you sure you want to remove this favorite?",
  "removeFavoriteOrderSucess": "Order removed from favorites.",
  "removeFavoriteSucess": "Your favorite has been removed.",
  "removeFromCartSuccess": "{itemName} removed from cart",
  "removeItem": "Remove Item",
  "removeItemFavorites": "Remove This Item From Favorites?",
  "removeItemFavoritesConfirm": "Are you sure you want to remove this favorite?",
  "removeItemFromCart": "Are you sure you want to remove your {item} from your cart?{offerText}",
  "removeItemFromCartOfferText": "Please note, removing this item will also remove the attached offer.",
  "removeItems": "Remove Items",
  "removeOne": "Remove one",
  "removeOneItemFromCart": "Remove one {itemName} from your cart.",
  "removeOneName": "Remove one {name}",
  "removePaymentMethod": "Remove payment method",
  "removeRestaurantFromFavorites": "Remove this restaurant from favorites",
  "removeReward": "Remove Reward",
  "removeRewardsFromCart": "Remove rewards from cart",
  "removeUnavailableEntries": "Remove Unavailable Entries?",
  "removeUnavailableItems": "Remove unavailable items",
  "reorder": "Reorder",
  "reorderWithOrderDescription": "Reorder {orderDesc}",
  "reorderWithOrderNumber": "Reorder number {ticketNumber}",
  "replace": "Replace",
  "replaceCoupon": "Would you like to replace the coupon already in your cart?",
  "replaceItem": "Replace Item",
  "replaceOffer": "Would you like to replace the offer already in your cart?",
  "replaceReward": "Replace Reward",
  "replaceRewardText": "You already have a reward selected. Are you sure you want to replace it?",
  "reportAnIssue": "Report An Issue",
  "reportIssue": "Report Issue",
  "reportOrderIssuePageTitle": "Report Order Issue",
  "requestMyInfo": "Request my info",
  "requestMyInformation": "Request my information",
  "requestNewLinkAuthEmail": "request a new link",
  "requestedAmount": "Requested Amount",
  "required": "Required",
  "requiredDate": "A valid date is required",
  "requiredField": "This is a required field",
  "resend": "Resend",
  "resendCode": "Resend Code",
  "resendCodeSuccess": "Email resent. Please check your email.",
  "reset": "Reset",
  "resetCustomizationsDescription": "Selecting this option will clear any customization applied to your order. Would you like to continue?",
  "resetCustomizationsHeader": "Reset Customizations",
  "resetLocationButtonAria": "Click here to reset the map to your current location.",
  "responsibility": "Responsibility",
  "restartPurchaseProcessButton": "Choose a Different Restaurant",
  "restartPurchaseProcessDisclaimer": "Selecting a new restaurant will empty your cart and start a new order.",
  "restaurantClosed": "Restaurant closed",
  "restaurantClosedDialogBody": "No worries, you can still order from a different restaurant nearby.",
  "restaurantClosedDialogBodyClosestOptionAvailable": "Closest option available:",
  "restaurantClosedDialogBodyDelivery": "Sorry, all delivery restaurants are closed. Try again later or choose pickup.",
  "restaurantClosedDialogBodyLoading": "Searching for a nearby restaurant...",
  "restaurantClosedDialogButton": "Confirm New Restaurant",
  "restaurantClosedDialogButtonCancel": "Choose a Different Restaurant",
  "restaurantClosedDialogButtonDelivery": "Switch to Pickup",
  "restaurantClosedDialogHeading": "Selected Restaurant Closed",
  "restaurantClosedDialogHeadingDelivery": "Delivery Unavailable",
  "restaurantCloses": "Restaurant closes in {minutes} min",
  "restaurantDetails": "Restaurant Details",
  "restaurantOrder": "Restaurant Order",
  "restaurantOrderComingSoon": "Restaurant Order Coming Soon!",
  "restaurantPriceChangeToast": "The price of your order was updated",
  "restaurantRedemption": "Already at a restaurant and ready to redeem? {clickHere}",
  "restaurantRedemptionClickHere": "Click here",
  "restaurantUnavailableErrorMessage": "The store you selected isn't able to accept mobile orders at this time.",
  "restaurantUnavailableErrorTitle": "Restaurant Currently Unavailable",
  "restaurants": "Restaurants",
  "resultsLeft": "{count} results left",
  "retakePhoto": "Retake",
  "retry": "Retry",
  "retryMessage": "We’re having trouble showing your progress on this offer. Please refresh or check back later.",
  "returnToMenu": "Return to menu",
  "returnToRewards": "Return To Rewards",
  "review": "Review",
  "reviewPhoto": "Review Photo",
  "reviewYourMeal": "Review Your Meal",
  "reviewYourOrder": "Review your order",
  "reviewYourSelection": "Review Your Selection",
  "reward": "Reward",
  "rewardAfterXPurchases": "Get rewarded after {pointsUntil} purchases",
  "rewardApplied": "Reward applied",
  "rewardCategory": "{categoryName} reward levels{selectedOptionText}",
  "rewardInfo2": "Purchases over $0.50 and at least 30 minutes apart will qualify.",
  "rewardInfo3": "You can bank up to 5 Rewards at a time.",
  "rewardInfo4": "When you redeem a Reward, the most expensive eligible item in your order will be FREE",
  "rewardPhoneNumberMessage": "Or give this number to the cashier",
  "rewardRedeemed": "Reward Redeemed",
  "rewardRedemptionListEmptyState": "Add {offers} and {rewards} to your order",
  "rewardSavings": "Reward Savings",
  "rewardUnavailable": "Not available",
  "rewardUnlocked": "Nice! Reward Unlocked",
  "rewardXInfo1": "Make {pointsUntil} purchases at an eligible Tims restaurant and get a FREE reward on eligible items.",
  "rewards": "Rewards",
  "rewardsAndOffers": "Rewards & Offers",
  "rewardsHistory": "Rewards History",
  "rewardsLevelChange": "Reward level updated.",
  "rewardsMainImage": "Rewards main image",
  "rewardsManagementChangeRewardLevel": "Change Reward Level",
  "rewardsManagementChoosenLevel": "Chosen Reward Level",
  "rewardsManagementPoints": "{points} Crowns",
  "rewardsPointsAmount": "Rewards, {points} Crowns",
  "rewardsPointsBalanceIsNow": "Your Tims Rewards Crowns balance is now {remainingPoints}.",
  "rewardsPointsDetailsMessage": "You have {points} Crowns",
  "rewardsPointsTitle": "Tims Rewards Crowns",
  "rewardsPolicy": "Rewards Terms",
  "rollsAddedToAccountText": "RRROLL{numberOfRollsShared, plural, one { has} other {S have}} been added to your account.",
  "rollsClaimedMessage": "You've just claimed {numberOfRollsShared, plural, one {a} other {{numberOfRollsShared}}} RRROLL{numberOfRollsShared, plural, one {} other {S}}!",
  "roundUpDescription": "Round up your orders to the nearest $0.10 when scanning your Tims Rewards or ordering ahead through the app to support Tim Hortons® Foundation Camps and help kids in your community. {link}.",
  "roundUpTitle": "Round up your order for Tims Camps?",
  "routes.accepted": "/accepted",
  "routes.account": "/account",
  "routes.accountDelete": "/account/delete",
  "routes.accountRequestInfo": "/account/request-information",
  "routes.bkRewards": "/bkrewards",
  "routes.catering": "/catering",
  "routes.claimPointsBase": "/claim-points",
  "routes.claimPointsProcessing": "/claim",
  "routes.claimPointsSurvey": "/survey",
  "routes.deleteMyAccount": "/delete-my-account",
  "routes.deliveryTerms": "/delivery-terms",
  "routes.exploreMenu": "/explore-menu",
  "routes.favoriteStoreSearch": "/favorite-store-search",
  "routes.hockey-challenge-en": "/hockey-challenge*",
  "routes.hockey-challenge-fr": "/defi-hockey*",
  "routes.iCampaign": "/icampaign",
  "routes.linkPhysicalCard": "/link-card",
  "routes.lovethatgame": "/lovethatgame",
  "routes.loyaltyActivateQuest": "/activate-challenge",
  "routes.loyaltyBannerAuthenticated": "/rewards/details",
  "routes.loyaltyBannerUnauthenticated": "/rewards/details",
  "routes.loyaltyDashboard": "/rewards/details",
  "routes.loyaltyHome": "/rewards",
  "routes.loyaltyOfferList": "/rewards/offers",
  "routes.loyaltyRewardList": "/rewards/list",
  "routes.mobileOrderingAndPaymentTerms": "/mobile-ordering-and-payment-terms",
  "routes.pandemonium": "/pandemonium",
  "routes.perksTermsConditions": "/perks-terms-conditions",
  "routes.plkSignupHeadlineRewardsLink": "/rewards/details",
  "routes.popeyesRewards": "/popeyes-rewards",
  "routes.privacyPolicy": "/privacy-policy",
  "routes.questLibrary": "/quest-library",
  "routes.redemptionInRestaurant": "/redeem",
  "routes.reusables": "/reusable",
  "routes.rewards": "/rewards",
  "routes.rewardsHistory": "/rewards/history",
  "routes.rewardsOnboarding": "/rewards-onboarding",
  "routes.rewardsPolicy": "/rewards-policy",
  "routes.roadtrip": "/roadtrip",
  "routes.rollUpTheRim": "/roll-up-to-win",
  "routes.rollUpTheRimOtherLanguage": "/deroule-pour-gagner",
  "routes.rollUpTheRimRules": "/rutw-rules",
  "routes.rollUpTheRimSharedRolls": "/roll-up-to-win/send",
  "routes.rollUpTheRimSharedRollsOtherLanguage": "/deroule-pour-gagner/envoyez",
  "routes.rollUpTheRimToWin": "/roll-up",
  "routes.scan": "scan",
  "routes.scanTH": "/scan",
  "routes.scanTimRewards": "/scan/tim-rewards",
  "routes.sendGift": "/gift",
  "routes.signIn": "/signin",
  "routes.signUp": "/signup",
  "routes.storeLocator": "/store-locator",
  "routes.storeLocator.address": "/store-locator/address",
  "routes.termsConditionsRewards": "/terms-conditions-rewards",
  "routes.termsOfService": "/terms-of-service",
  "routes.termsOfService.th": "/terms-of-use",
  "routes.textTerms": "/text-terms",
  "routes.timCard": "/account/tim-card",
  "routes.tims-for-good-en": "/tims-for-good",
  "routes.tims-for-good-fr": "/timdubienauquotidien",
  "routes.timsRewardSelection": "/tims-rewards/reward-selection",
  "routes.timsRewards": "/tims-rewards",
  "routes.timsRewardsNew": "/timsrewards",
  "routes.timsRewardsTab": "/tims-rewards/:tab",
  "routes.timsRewardsTermsAndConditions": "/terms-conditions-rewards",
  "royalPerks": "Royal Perks",
  "royalPerksMembers": "Royal Perks members",
  "royalPerksMembersEnjoy": "Royal Perks members enjoy",
  "royalPerksMembershipDiscount": "Get 40% off Walmart+ annual membership.",
  "ruleSetsCannotRedeemAgain": "You have reached the limit for redemptions on this offer. {redeemableInString}",
  "ruleSetsCannotRedeemNow": "You cannot redeem this offer now. {redeemableInString}",
  "ruleSetsCartPropertyViolation": "Your cart does not meet the requirements for this offer.",
  "ruleSetsDayOfWeekViolation": "You cannot redeem this offer today. {redeemableInString}",
  "ruleSetsFirstOrderOnlyViolation": "You can only redeem this offer on your first order.",
  "ruleSetsPurchaseViolation": "You do not have the the required items in your cart to redeem this offer.",
  "ruleSetsRequiresAssignmentViolation": "You are not eligible for this offer.",
  "safteyIssue": "Safety Issue",
  "salt": "Salt",
  "saturatedFat": "Saturated Fat",
  "saturday": "Saturday",
  "save": "Save",
  "saveAddressDisclaimer": "Please save my phone number and delivery address for faster checkout the next time I place an order.",
  "saveAddressLabel": "Save My Information. {disclaimer}",
  "saveCardDisclaimer": "Save Card, by saving your card you consent for your card to be stored and used for purchases.",
  "saveCardDisclaimer.plk": "Save Card, by saving your card you consent for your card to be stored and used for purchases and as your Popeyes Rewards linked card.",
  "saveCardDisclaimerRedesign": "By Saving your card you consent for your card to be stored and used for purchases",
  "saveChanges": "Save Changes",
  "saveFavoriteOrderButton": "Save In Favorites",
  "saveFavoriteOrderNameError": "Please enter an order name.",
  "saveFavoriteOrderSucess": "Order saved to favorites!",
  "saveFavoriteOrderText": "What would you like to name this order?",
  "saveFavoriteOrderUnsaved": "You Have Unsaved Changes",
  "saveFavoriteOrderUnsavedBody": "Do you want to continue without saving your changes in the favorite order?",
  "saveInformationToMyAccount": "Remember my phone number and address for future delivery orders.",
  "saveMyPointsForLater": "Save my crowns for later",
  "savedAddresses": "Saved Addresses",
  "savedOrder": "Your order has been saved.",
  "savedOrderTapImClose": "Order saved. Tap \"I'm Close\" when you are 5 minutes away. Your card won't be charged until then.",
  "savedOrdertapImHere": "Your order has been saved. Tap \"I'm Here\" when you arrive so we can prepare your order. Your card won't be charged until then.",
  "scan": "Scan",
  "scanAndPay": "Scan & pay",
  "scanAndPayHasBeenDisabled": "Scan & Pay Has Been Disabled",
  "scanAndPayPaymentMethodUpdated": "Successfuly Updated Scan & Pay Payment Method",
  "scanBarcode": "Scan Barcode",
  "scanForTimsRewards": "Scan for Tims Rewards",
  "scanForTimsRewardsBeforePaying": "Scan for Tims Rewards before paying",
  "scanMoreRewards": "Scan for more rewards",
  "scanQRCode": "Scan your QR code if you are paying in restaurant.",
  "scanQr": "Scan QR code",
  "scanQrTitle": "Scan QR code before ordering",
  "scanRewards": "Scan Rewards",
  "scanRewardsCard": "Scan Rewards Card",
  "scanSuccessful": "Scan Successful!",
  "scanTimCardTerminal": "Scan your Tims Rewards Card at the terminal",
  "scanToEarnPoints": "Scan to Earn Crowns",
  "scanToEarnPointsPayAndUseRewards": "Scan to earn crowns, pay and use rewards",
  "scanToEarnRewardsAndPay": "Scan To Earn Rewards & Pay",
  "scanToPayWithTimCard": "Scan to Pay",
  "scanToPayWithYourTimCard": "Scan to Pay with Your Tim Card",
  "scanYourTimCardAtTheTerminal": "Scan your TimCard at the terminal",
  "scanYourTimsCardToGetRewards": "Scan your Tims Rewards card to get rewards for this visit!",
  "scheduledTime": "Scheduled for: ",
  "school": "School",
  "searchLocation": "Search Location",
  "searchLocations": "Search Locations",
  "searchThisArea": "Search this area",
  "seasonalTreats": "Seasonal Treats",
  "seconds": "seconds",
  "seeDeliveryPartners": "See Delivery Partners",
  "seeDetails": "See details",
  "seeMoreOptions": "See more options",
  "select": "Select",
  "selectACountry": "Select a country",
  "selectAFilter": "Select a filter...",
  "selectAnyways": "Select Anyways",
  "selectBestRewardLevel": "Select the reward level that best fits you! You can change it at any time.",
  "selectDonationAmount": "Select Donation Amount",
  "selectGift": "Select Gift",
  "selectGiftError": "Please select a gift.",
  "selectLanguage": "Select Language",
  "selectLocation": "Select Location",
  "selectManually": "Select Manually",
  "selectOffer": "Select Offer",
  "selectPaymentMethod": "Select a payment method",
  "selectPaymentMethodDrawer": "Select Payment Method",
  "selectPaymentMethodToAddFunds": "Please select the payment method that will be used to add funds to your account.",
  "selectPickup": "Select pickup method",
  "selectQuantity": "Select Quantity",
  "selectRemaining": "Select {amount} More",
  "selectRestaurant": "Select Restaurant",
  "selectRestaurantToViewOffers": "Select restaurant to view local offers",
  "selectSingleChoice": "Select {amount} {itemName}",
  "selectSize": "Select Your Size",
  "selectStore": "Select Store",
  "selectTheCorrectAnswer": "Select the correct answer",
  "selectThisStore": "Select {storeLabel} store",
  "selectUpTo": "Select up to {amount} {itemName}",
  "selectYourAccompaniments": "Select your accompaniments",
  "selected": "Selected",
  "selectedRestaurant": "Selected Restaurant",
  "selectedRewardLevelAndBankMyRewards": "Selected Reward Level and Bank My Rewards",
  "selectingStartOver": "Selecting Start Over will empty your cart and start a new order.",
  "selectionNotAvailable": "Sorry, your selection is not available.",
  "sendAnotherGift": "Send Another Gift",
  "sendGift": "Send Gift",
  "sendGiftEmailRequiredError": "Please enter the recipient’s email.",
  "sendGiftImage": "Send a gift image",
  "sendGiftNameRequiredError": "Please enter your full name.",
  "sendNewCode": "Send New Code",
  "september": "September",
  "serviceFee": "Service Fee",
  "serviceFeeDescription": "Variable fee consists of {percent}% of your delivery order (excl. taxes).",
  "serviceModeDetailsCurbsideDescription": "Grab a parking spot and we’ll bring your order out to your car.",
  "serviceModeDetailsCurbsideDescriptionV2": "At Parking Lot",
  "serviceModeDetailsCurbsideHeader": "Curbside Pickup",
  "serviceModeDetailsDineInDescription": "Come in and head to the Pick Up area at the counter to check in with a Team Member. Then find a seat to enjoy!",
  "serviceModeDetailsDineInDescriptionV2": "At Counter",
  "serviceModeDetailsDineInHeader": "Dine In",
  "serviceModeDetailsDriveThruDescription": "Drive up and let us know you placed an online order.",
  "serviceModeDetailsDriveThruDescriptionForMobileOrder": "Drive up to our dedicated Mobile Order Lane and we'll walk your order out to your car.",
  "serviceModeDetailsDriveThruDescriptionV2": "At Drive Thru Lane",
  "serviceModeDetailsDriveThruHeader": "Drive Thru",
  "serviceModeDetailsDriveThruHeaderForMobileOrder": "Mobile Order Drive Thru",
  "serviceModeDetailsMobileOrderDriveThruDescriptionV2": "At Mobile Order Drive Thru Lane",
  "serviceModeDetailsOrderBayDescription": "Sit back and relax, you'll receive a notification on the screen in front of you when your order is ready.",
  "serviceModeDetailsOrderBayHeader": "Order Bay",
  "serviceModeDetailsPickupDescription": "Head to the Pick Up area at the counter to check in with a Team Member.",
  "serviceModeDetailsPickupDescriptionV2": "At Counter",
  "serviceModeDetailsPickupHeader": "Pick Up",
  "serviceModeDetailsUnavailable": "Unavailable",
  "serviceModePrompt": "How would you like to get your food?",
  "serviceModePromptAlternative": "What type of order will this be?",
  "serviceModeSelectorTitle": "Select your pickup method",
  "serviceModeSwitchedAutomatically": "Selected mode unavailable. Switched automatically.",
  "serviceVisit": "Support Crowns",
  "sesame": "sesame",
  "setAsDefaultPayment": "Set as Default Payment",
  "setPickup": "Set your pickup method ",
  "setRestaurantAsFavorite": "Set this restaurant as a favorite",
  "setRewardsTierError": "Sorry, we couldn't set your reward level please check your connection and try again.",
  "shakes": "Shakes",
  "share": "Share",
  "shareMyLocation": "Share Location",
  "shareRollsPageButtonText": "Share {rollsToShare} RRROLL{rollsToShare, plural, one {} other {S}}",
  "shareRollsPageRollToText": "RRROLL{rollsRemaining, plural, one {} other {S}} to",
  "shareYourLocation": "Share your location",
  "shareYourRoll": "Share your rolls and Roll Up to Win™!",
  "sharedLandingButtonText": "Rrroll Now",
  "shellfish": "shellfish",
  "shoppingCartPreview": "Shopping cart preview",
  "shortCodeConfirmationBody": "Your Royal Perks have been added to the order.",
  "shortCodeConfirmationHeader": "You're All Set!",
  "showDetails": "Show details",
  "showLess": "Show Less",
  "showMeDeals": "Show me Deals",
  "showMore": "Show More",
  "signIn": "Sign In",
  "signInCodeSentToEmailAgain": "Your sign in code has been sent to your email! Please also check your spam folder.",
  "signInCodeSentToPhoneAgain": "Your sign in code has been sent to your phone number!",
  "signInIfYouAlreadyHaveAccount": "Log in if you already have an account",
  "signInOrCreateAccount": "Log In or Create Account",
  "signInSuccess": "You have successfully signed in.",
  "signInToViewOffers": "Sign in to view offers",
  "signInToViewOrders": "Log In To View Orders",
  "signInUp": "Sign Up / Sign In",
  "signOut": "Sign Out",
  "signOutConfirmSubheader": "Are you sure you want to sign out?",
  "signUp": "Sign Up",
  "signUpError": "An error occurred while signing up.",
  "signUpForBkRewards": "Sign up for BK Rewards",
  "signUpForPromotionalEmails": "Sign Up for Promotional Emails",
  "signUpForPromotionalEmailsPopeyesRewards": "Yes! I want to receive Popeyes® Perks emails to gain access to exclusive offers and be the first to know about the latest Popeyes promotions",
  "signUpNow": "Login",
  "signUpNowToGetStartedWith": "Sign up now to get started with {rewardsLink}",
  "signUpOrLoginToContinue": "Sign Up or Log In to Continue",
  "signUpOrSignIn": "Sign Up or Sign In",
  "signUpRoyalPerksForFree": "Sign up for Royal Perks for free and you’ll get the best deals, every day",
  "signUpSuccessSignInFail": "Your account has been created. Please log in to continue.",
  "signUpToContinue": "Sign Up to Continue",
  "signUpToContinueDisclaimer": "Taxes and Fees will be calculated in your final cart. Sign up or log in to review and complete your order.",
  "signUpToCreateAccount": "Sign up to create an account",
  "signUpToGetStartedWith": "Sign up to get started with {rewardsLink}",
  "signUpToRedeem": "Sign Up To Redeem",
  "signUpToStartEarning": "Sign up for Royal Perks to start earning and redeeming BK Crowns in-store and online.",
  "signinToRedeem": "Log in to redeem",
  "signupEmailSent": "We just sent an email with login instructions to {email}. Enter verification code below",
  "singleUseCupFee": "Single Use Cup Fee",
  "sitemap": "Sitemap",
  "skip": "Skip",
  "skipTheLinePart1": "Skip",
  "skipTheLinePart2": "The",
  "skipTheLinePart3": "Line",
  "skipToContent": "Skip to content",
  "slowNetworkIssue": "We are still processing your request. This may take slightly longer than usual.",
  "smallCartFee": "Small Cart Fee",
  "smallCartFeeDescription": "Additional fixed fee applicable to delivery orders less than {amount} (excl. taxes). You may add items to remove fee.",
  "sms": "SMS",
  "smsSubscriptionConfirmation": "Great! Keep an eye out for a text with the next steps.",
  "smsSubscriptionUpdateError": "There was an error with your subscription request. Please try again later.",
  "sodium": "Sodium",
  "softs": "Soft Drinks",
  "someItemsAreUnavailableInSelectedStore": "Some of the items in your cart are not available at this store. Please remove these items to continue with your selection or cancel to keep your current store.",
  "someItemsAreUnavailableMessage": "Some items in your cart aren't currently available from your selected store. Please remove these selections and try again.",
  "someItemsNotAvailable": "Some Items Not Available",
  "somethingMissingHere": "Something's missing here",
  "somethingWentWrong": "Something went wrong",
  "somethingWentWrongRemovingAddress": "Something went wrong while removing the address. Please try again.",
  "somethingWrong": "Something went wrong",
  "sorryMinimumCashApp": "Sorry! Minimum order for paying with Cash App is $1.00. Add more items or change your payment method.",
  "sorrySomethingWentWrong": "Sorry, something went wrong!",
  "soy": "soy",
  "specialOffers": "Special Offers",
  "staffing": "Staffing",
  "standardsOfBusinessPractices": "Standards of business practices",
  "startCateringOrderNow": "Start your catering order now",
  "startChallenge": "Start Challenge",
  "startEarningRewards": "Start earning rewards",
  "startNow": "Start Now",
  "startOrder": "Start Order",
  "startOver": "Start Over?",
  "startOverDisclaimer": "Selecting Start Over will empty your cart and start a new order.",
  "startOverInX": "Start over in {timeRemaining}",
  "startPlayingMessage": "Now you can start playing!",
  "startQuest": "Start Quest",
  "startYourCateringOrderNow": "Start your Catering Order now",
  "startYourOrder": "Start Your Order",
  "startYourOrderHerePart1": "Start your",
  "startYourOrderHerePart2": "order here",
  "state": "State",
  "stateIsARequiredField": "State is a required field",
  "stay": "Stay",
  "stayOnPage": "Stay On Page",
  "stillThere": "Still there?",
  "storeAddress": "{name}{conditionalLinebreak}{address1}{linebreak}{city}, {stateProvince} {postalCode}",
  "storeClosed": "THE STORE YOU SELECTED ISN'T OPEN AT THIS TIME",
  "storeConfirmationCateringDelivery": "Catering Delivery at {location}",
  "storeConfirmationCateringPickup": "Pick Catering up at {location}",
  "storeConfirmationCurbside": "Curbside at {location}",
  "storeConfirmationDefault": "Place Order at {location}",
  "storeConfirmationDelivery": "Delivery at {location}",
  "storeConfirmationDriveThru": "Drive Thru at {location}",
  "storeConfirmationDriveThruMobileOrder": "Mobile Order Lane at {location}",
  "storeConfirmationEatIn": "Dine in at {location}",
  "storeConfirmationFastLaneDriveThru": "Fast Lane Drive Thru at {location}",
  "storeConfirmationPickup": "Pick up at {location}",
  "storeConfirmationTakeout": "Takeout at {location}",
  "storeCurrentlyClosed": "Store Currently Closed",
  "storeDoesNotHaveMobileOrdering": "This store does not have mobile ordering.",
  "storeInfo": "Info & Photo",
  "storeInfoAssistive": "See information for {storeLabel} store",
  "storeIsClosingError": "This store is closing soon and is no longer accepting mobile orders.",
  "storeLocations": "Store Locations",
  "storeLocator": "Store Locator",
  "storeLocatorClosePromptBody": "To view the offers available, you need to select a store first. What would you like to do?",
  "storeLocatorClosePromptHeading": "Select a Store to See Offers",
  "storeLocatorEmptyStateDefaultBody": "Search for a restaurant near you.",
  "storeLocatorEmptyStateDefaultTitle": "Find a Location",
  "storeLocatorEmptyStateFavoritesErrorBody": "Looks like something went wrong on our end. Try reloading the page or searching for an address on the Nearby tab.",
  "storeLocatorEmptyStateFavoritesErrorTitle": "Uh oh! Sorry.",
  "storeLocatorEmptyStateFavoritesNoAuthBody": "To set a favorite location, first log in or sign up for an account.",
  "storeLocatorEmptyStateFavoritesNoAuthTitle": "Log In to Save Favorites",
  "storeLocatorEmptyStateFavoritesNoStoresBody": "Tap the heart on a store to save it as a favorite.",
  "storeLocatorEmptyStateFavoritesNoStoresTitle": "No Favorites Yet",
  "storeLocatorEmptyStateNearbyErrorBody": "Looks like something went wrong on our end. Try entering an address or finding your location on map.",
  "storeLocatorEmptyStateNearbyErrorTitle": "Uh oh! Sorry.",
  "storeLocatorEmptyStateNearbyNoLocationBody": "Let us know where you are so we can recommend nearby locations.",
  "storeLocatorEmptyStateNearbyNoLocationTitle": "Find a Location Nearby",
  "storeLocatorEmptyStateNearbyNoStoresBody": "No nearby locations are available at this time. Try entering a new address or city.",
  "storeLocatorEmptyStateNearbyNoStoresTitle": "No Nearby Locations",
  "storeLocatorEmptyStateRecentErrorBody": "Looks like something went wrong on our end. Try reloading the page or searching for an address on the Nearby tab.",
  "storeLocatorEmptyStateRecentErrorTitle": "Uh oh! Sorry.",
  "storeLocatorEmptyStateRecentNoAuthBody": "First log in or sign up for an account.",
  "storeLocatorEmptyStateRecentNoAuthTitle": "Log In to See Recent Locations",
  "storeLocatorEmptyStateRecentNoStoresBody": "You have no recent locations. Let's change that! Try entering an address and placing an order.",
  "storeLocatorEmptyStateRecentNoStoresTitle": "Oh! Hold Up",
  "storeLocatorExperimentEmptyStateNearbyNoLocationBody": "Let us know where you are so we can recommend nearby locations or enter and address above.",
  "storeNoOrderingBody": "Try selecting a different location, or visit us in person to place this order",
  "storeNoOrderingHeading": "The restaurant you selected isn't accepting mobile orders at this time",
  "storeUnavailable": "Store Unavailable",
  "streetAddress": "Street address",
  "submit": "Submit",
  "submitAnswer": "Submit Answer",
  "submitEmail": "Submit Email",
  "submitFeedback": "Submit Feedback",
  "submitYourPhoto": "Submit Your Photo",
  "subtotal": "Subtotal",
  "success": "Success",
  "successfulCardDeactivation": "Your card was successfully deactivated and your digital card has been updated",
  "successfullyCreatedSupportCase": "Your support case has been successfully submitted!",
  "successfullyUpdatedUserAccountInfo": "Account information has been updated.",
  "sugar": "Sugar",
  "sulphurDioxide": "sulphur dioxide",
  "sunday": "Sunday",
  "support": "Support",
  "supportFormDeliveryActive": "It looks like your order has not been dropped off yet, if you need additional help please reach out below.",
  "supportFormOrderAlreadyRefunded": "It looks like you have already received a refund for this order, if you need additional help please reach out below.",
  "supportFormRefundGenericError": "We are so sorry you experienced an issue with your order, please describe your issue below.",
  "supportFormSelectIssue": "Select Your Issue",
  "supportSubcategoryTitle": "{category} issues",
  "supportTopics": "Support Topics",
  "supportTopicsAll": "All Support Topics",
  "surprise": "surprise",
  "swipe": "Swipe",
  "switchServiceModeToDeliveryBody": "Switch to Delivery to place an order",
  "switchServiceModeToDeliveryButton": "Switch to Delivery",
  "switchServiceModeToDeliveryHeader": "Offer only available for Delivery",
  "switchServiceModeToPickupBody": "Switch to Pickup to place an order",
  "switchServiceModeToPickupButton": "Switch to Pickup",
  "switchServiceModeToPickupHeader": "Offer only available for Pickup",
  "switzerland": "Switzerland",
  "takeAdvantageOfLoyaltyProgram": "Take Advantage of Our Loyalty Program",
  "takeOut": "Take Out",
  "takeOutComingSoon": "Take Out COMING SOON",
  "takeOutUnavailable": "Take Out is currently unavailable",
  "takeout": "Take Out",
  "tapImClose": "Tap \"I’m close\" when you’re 5 minutes away so we can prepare your order. Your card won’t be charged until then.",
  "tapImClose.plk": "Tap \"I'm close\" when you’re 5 minutes away so we can prepare your order. Your card won’t be charged until then.",
  "tapImCloseCashPayment": "Tap \"I’m close\" when you’re 5 minutes away so we can prepare your order.",
  "tapImCloseCashPayment.plk": "Tap \"I’m close\" when you’re 5 minutes away so we can prepare your order.",
  "tapImHere": "Tap \"I'm Here\" when you arrive so we can prepare your order. Your card won't be charged until then.",
  "tapImHereCashPayment": "Tap \"I'm Here\" when you arrive so we can prepare your order.",
  "tapToOrder": "Tap to order",
  "tapToSeeDetails": "Tap to see details.",
  "tapWhenHere": "Tap When Here",
  "tapWhenYourAreHere": "Tap when you're here.",
  "tastySwaps": "Tasty Swaps",
  "tax": "Tax",
  "taxes": "Taxes",
  "taxesAndFees": "Taxes and Fees",
  "taxesAndFeesButtonAriaLabel": "Show taxes and fees",
  "taxesAndFeesNextStep": "Calculated at Final Step",
  "tenMin": "10 min",
  "termsAccessibilityLabel": "See terms for {cardTitle}",
  "termsConditions": "Terms & Conditions",
  "termsConditionsRewards": "Terms & Conditions",
  "termsOfService": "Terms of Service",
  "termsOfUse": "Terms of Use",
  "test_remove_me": "test_remove_me added to main",
  "textTerms": "BK Royal Perks Text Program",
  "th.acceptEmailsAndSpecialOffers": "Yes! I want to receive promotional emails about special offers and other information about Tim Hortons. (Optional)",
  "thDirectPayOnboardingText": "You can now pay directly with your credit/debit card. You'll be asked to confirm your card details if you select a previously saved card.",
  "thDirectPayOnboardingTitle": "New Payment Method!",
  "thTimsRewards": "Tims Rewards",
  "th_optInOutRewards": "We will message you about Tims Rewards to tell you about new program features and rewards. This includes sending you regular, personalised, special offers to earn more crowns and save money.",
  "thankYou": "Thank you!",
  "theCardBalanceIs": "The card {cardNumber} has a balance of",
  "theEmailAddressIsInvalid": "The email address you entered is invalid or does not exist. Please try again with a valid email, or contact support.",
  "thereAreErrorsInThisForm": "There are {numberOfErrors} errors in this form",
  "thereIsAnErrorInThisForm": "There is an error in this form",
  "theseAreOurFavorite": "These are our favorite",
  "thisIsScary": "This is scary... looks like your location services might not be on.",
  "thisMayTakeAFewSeconds": "This May Take A Few Seconds",
  "thursday": "Thursday",
  "timCard": "Tim Card",
  "timCardInstructions": "You can use your Tim Card to pay for all your purchases online and in-store.",
  "timCardScanErrorBody": "The barcode you scanned doesn't look like a TimCard. Try a different barcode?",
  "timCardScanErrorHeading": "That doesn't look like a TimCard.",
  "timHortons": "Tim Hortons",
  "time": "Time",
  "timeline": "Timeline",
  "timing": "Timing",
  "tims": "Tims",
  "timsCampDonation": "Tims Camps Donation",
  "timsCard": "Your Tims Rewards Card",
  "timsCardHeader": "Tim Card",
  "timsCardLostOrStolen": "If your Tims Rewards card is lost or stolen, you can deactivate it and remove it from your account. You'll receive a new digital card so you can continue earning. {linebreak} Don't worry, all your transactions and rewards will be saved to your account.",
  "timsCatering": "Tims Catering",
  "timsMenu": "Tims Menu",
  "timsRewards": "Tims Rewards",
  "timsRewardsDetails": "Tims Rewards details",
  "timsRewardsFaqLinkText": "Learn more here",
  "timsRewardsHeader": "Tims Rewards",
  "timsRewardsTermsAndConditions": "Tims Rewards Terms and Conditions",
  "tip": "Tip",
  "tipAmountError": "Please use a numeric character.",
  "tipAmountMaxError": "Can't exceed subtotal or be more than $50",
  "tipField": "Enter a tip amount (dollars)",
  "titleAllowLocation": "Your location is not available",
  "to": "to",
  "toAddress": "to {address}",
  "toEarnRolls": "to earn rolls",
  "today": "today",
  "toggleMenu": "Toggle menu",
  "togglePromoCode": "Enter Code Here",
  "togglePromoCodeAria": "Click here to add a promo code",
  "togglePromotionModal": "View saved promotions",
  "togglePromotionModalAria": "Click here to view saved promotions",
  "tomorrow": "tomorrow",
  "tooManyAddAccountAttempts": "You've tried adding a payment method too many times recently. Please try again later.",
  "topLevelUnlocked": "Congrats, {userName}! Top level unlocked!",
  "total": "Total",
  "totalAmountAdded": "Total amount added",
  "totalChoices": "Choose up to {amount} total",
  "totalFat": "Total Fat",
  "totalItemsInTheOrder": "There are {amount} items in the order",
  "totalPrice": "Total Price: {price}",
  "track": "Track",
  "trackOrder": "Track order",
  "trademarkAndCopyright": "TM & Copyright {year} Burger King Company LLC.",
  "trademarkAndCopyrightPopeyes": "TM & © 2021 Popeyes Louisiana Kitchen, Inc.",
  "trademarks": "Trademarks Notice",
  "transFat": "Trans Fat",
  "transfer": "Transfer",
  "transferBalance": "Transfer Balance",
  "transferBalanceCompletedMessage": "Congratulations! Your balance has been transferred.",
  "transferBalanceDirections": "First, enter the digits from the back of the card to look up the balance.",
  "transferBalanceError": "We were unable to process your request. Please try again or {link} for assistance.",
  "transferBalanceFromAnotherCard": "Transfer balance from another {cardAlias} card",
  "transferBalanceFromAnotherCrownCard": "Transfer balance from another crown card",
  "transferBalanceFromAnotherTimCard": "Transfer balance from another Tim Card",
  "transferBalanceFromCrownCard": "Transfer Crown Card Balance",
  "transferBalanceFromPrepaidCard": "Transfer {cardAlias} Card Balance",
  "transferBalanceFromTimCard": "Transfer balance from Tim Card",
  "transferGiftCard": "Transfer Gift Card",
  "transferGiftCardHasABalance": " has a balance of ",
  "transferGiftCardNewBalanceQuestion": " ?",
  "transferGiftCardTheCard": "The card ",
  "transferGiftCardToYourCardFor": " to your Card for a new balance of ",
  "transferGiftCardWouldYouLikeTo": "Would you like to transfer ",
  "transferGiftCardYourCurrentGift": "Your Current Gift Card Balance is ",
  "transferNow": "Transfer Now",
  "transferSuccessful": "Transfer successful",
  "transferXToMyGiftCard": "Transfer {balance} to my Tim Card",
  "treatYourself": "Treat yourself",
  "treeNuts": "tree nuts",
  "trending": "Trending",
  "troubleLoadingOrder": "We had some trouble connecting to the restaurant. We suggest selecting a different restaurant or trying again at a later time.",
  "tryAgain": "Try again",
  "tryEnablingYourLocation": "Try enabling your location services in settings and then be sure to try again to get your free Whopper® coupon.",
  "tryingToEnterPromoCode": "Trying to enter a Promo Code? Enter it {below}.",
  "tuesday": "Tuesday",
  "twelveDaysOfTims": "12 Days of Tims",
  "twentyMin": "20 min",
  "uhoh": "Uh oh!",
  "unableToLoadTimCardNoInternet": "Unable to load TimCard, please connect to internet.",
  "unableToPlaceOrder": "Unable To Place Order",
  "unableToProcessOrder": "Unable To Process Order",
  "unableToReloadCardError": "We were unable to reload your card.",
  "unauthenticatedFavoritesHeader": "Log In to Save Favorites",
  "unauthenticatedFavoritesSubtext": "Sign up or log in to save your favorites.",
  "unauthenticatedRecentItemsHeader": "Log In to View Recent Items",
  "unauthenticatedRecentItemsSubtext": "Once you're logged in, your recently ordered items will appear here.",
  "unavailable": "Unavailable",
  "unavailableAtLocation": "Unavailable at this location",
  "unit": "Unit",
  "unitNumber": "Unit {unitNumber}",
  "unitNumberInput": "Unit",
  "unitNumberLabel": "Unit (Optional)",
  "unitNumberLabelRequired": "Unit (Required)",
  "unitedKingdom": "United Kingdom",
  "unitedStates": "United States",
  "unlock": "Unlock",
  "unlockCartReq": "to your cart to unlock this deal.",
  "unlockedPromoCodeOffer": "Offer unlocked",
  "unregisterYourCard": "You may unregister your card at any time within Account settings.",
  "unsavedChangesBody": "You’ve made changes to this address. Do you want to save them before leaving?",
  "unsavedChangesHeading": "Unsaved Changes",
  "unsavedChangesModalDescription": "Do you want to save your customization changes?",
  "unsavedChangesModalHeader": "Unsaved Changes",
  "unsupportedCardEntered": "Unsupported card entered",
  "unsupportedCardType": "Sorry, we don't currently support {cardType}",
  "until": "until",
  "unverified": "Unverified",
  "unverifiedCard": "Unverified Card",
  "unwrapping": "Unwrapping...",
  "upArrowChevronIcon": "Up Arrow",
  "upateAddress": "Update Address",
  "update": "Update",
  "updateApp": "Update App",
  "updateBrowserLocationSettings": "Please allow location access in your browser and operating system settings.",
  "updateCard": "Update Card",
  "updateCart": "Update Order",
  "updateCartSuccess": "{itemName} updated in cart.",
  "updateDeviceLocationSettings": "Go to your device settings to allow location access for the {brand} app",
  "updateInfoError": "An error occurred updating your information.",
  "updateItem": "Update Item",
  "updateLater": "Update Later",
  "updateNow": "Update Now",
  "updateOrderErrorMessage": "We encountered an error updating your order. Please try again or come to the counter to chat with us.",
  "updatePaymentMethod": "Update Payment Method",
  "updateQuantityAndItemWithPrice": "Update {quantity} {itemName} for {price}",
  "updateRewardLevel": "Update Reward Level",
  "uponOrderDelivery": "Upon order delivery",
  "uponOrderPickup": "Upon order pickup",
  "upsellItemLabel": "{itemName} {calories} {price}",
  "upsizeEligible": "You are eligible for one item upsize.",
  "upsizeForFree": "One Upsize Free!",
  "upsizeSelection": "Please select your upsize",
  "us-calories": "Calories",
  "us-carbohydrates": "Carbohydrates",
  "us-cholesterol": "Cholesterol",
  "us-fat": "Fat",
  "us-fiber": "Fiber",
  "us-proteins": "Proteins",
  "us-salt": "Salt",
  "us-saturatedFat": "Saturated Fat",
  "us-sodium": "Sodium",
  "us-sugar": "Sugar",
  "us-transFat": "Trans Fat",
  "us-weight": "Weight",
  "useCodeAtCashier": "Use code at cashier",
  "useDifferentAddress": "Use Different Address",
  "usePointsToday": "Use your crowns today",
  "useRewards": "My Reward Level",
  "useSavedAddressPhone": "Use Saved Address & Phone",
  "useYourWalmartPlusAccount": "Use your preferred email to sign up or if you are already part of Royal Perks, sign in",
  "usedAllCoupons": "Looks like you have used all of the current coupons\nWe update periodically so keep an eye out for new ones.\nThanks for being a loyal customer.",
  "userAuthEmailNotVerified": "The email provided is not verified by the provider, please make the verification and try again.",
  "userAuthEmailNotVerifiedTitle": "Social Account Login Failed",
  "userAuthLookupFailed": "We have some issues searching the user, please try again in a few min.",
  "userAuthProxyEmail": "We couldn't have access to your email address, please allow us to access it, in another case we are not able to continue. \n\nOn apple devices you have to follow this steps:\n - Go to device configuration\n - Apple ID\n - Password & Security\n - Sign in with Apple\n - Select Burger King app\n - Click on Stop Using Apple ID\n - Try to login again and approve the email access permission",
  "userAwayFromStore": "You seem far away.",
  "userDoesNotExist": "This user does not exist",
  "userPhoneVerified": "You have successfully verified your phone number",
  "userSocialLoginEmailUnavailable": "We are unable to retrieve an email address associated with your {providerType} account.\nPlease verify you have an email connected to this account.",
  "userSocialLoginFailed": "Social Account Login Failed",
  "userSocialLoginGenericErrorDescription": "We encountered an error while validating your social account. Please ensure your credentials are correct, or try using an alternative login method.",
  "validationCode": "Validation code",
  "validationError": "Please check your order details and try again",
  "validationErrorHeading": "Order Error",
  "venmo": "Venmo",
  "verified": "Verified",
  "verify": "Verify",
  "verifyEmailForRewards": "Verify your email to link a physical card",
  "verifyNow": "Verify now",
  "verifyYourEmail": "Verify Your E-mail",
  "verifyYourEmailInstructions": "In order to access all the features in your account, please verify your e-mail.",
  "verifyYourPhoneInstructions": "In order to sign in using your phone number, please verify your phone number.",
  "verifyYourPhoneNumber": "Verify Your Phone Number",
  "view": "View",
  "viewAll": "View all",
  "viewAllOffers": "View all offers",
  "viewAllPurchases": "View all your purchases.",
  "viewAllRecentItems": "View all recent items",
  "viewAllRewards": "View all rewards",
  "viewAvailableOffersToast": "An offer was removed when you switched stores.",
  "viewAvailableOffersToastLink": "View available offers at your selected store",
  "viewCart": "View Cart",
  "viewDetails": "View Details",
  "viewDetailsWithOrderNumber": "View details of order number {ticketNumber}",
  "viewHistory": "View History",
  "viewMenu": "View Menu",
  "viewOffers": "View Offers",
  "viewOnMap": "View on Map",
  "viewOrder": "View Order",
  "viewOrderWithDescription": "View order {orderDesc}",
  "viewPurchasesAndOffers": "View all of your purchases here, including Crowns earned and Crowns redeemed.",
  "viewReceipt": "View Receipt",
  "viewRecentOrders": "View Recent Orders",
  "viewRewards": "View Rewards",
  "viewStoreHours": "View Store Hours",
  "viewTerms": "View Terms",
  "viewYourPurchases": "View all your purchases here, including\nCrowns earned and redeemed.",
  "visitSupport": "Visit Support",
  "visitSupportForHelpWithYourCurrentOrder": "Visit support for help with your current order.",
  "visitSupportForHelpWithYourOrder": "Visit support for help with your order.",
  "visits": "Visits",
  "visitsAwayFromReward": "visits away from your next reward",
  "visuallyHiddenOpenInAppOrBrowser": "Please click the Open The App button to proceed to the mobile app. If you want to continue to the website, click the Continue on the Website button. This will trigger another login code for you to log in to the website with.",
  "visuallyHiddenSelectItem": "Select {itemName}",
  "visuallyHiddenSignInCodeSentToEmail": "We sent a 6 digit login code to your email address, please type the login code into the input box on the screen.",
  "visuallyHiddenSignInCodeSentToPhone": "We sent a 6 digit login code to your phone number, please type the login code into the input box on the screen.",
  "visuallyHiddenSignInSuccess": "You have been signed in!",
  "visuallyHiddenVerifyingOTP": "Verifying",
  "voucherCodeError": "Please enter a Promo code",
  "voucherNotFound": "Promo code invalid or expired. Trying to Link your Physical Card? Enter it {above}.",
  "voucherUsed": "This Promo code has already been used",
  "waitForReply": "Keep an eye on your email inbox – we typically respond within 24 – 48 hours.",
  "waitingForCamera": "Camera is Loading",
  "walmartAccountAlreadyConnected": "Hi {userName}, A Walmart+ account is already connected with your account",
  "walmartAccountLinkingInterrupted": "The process of linking your accounts was interrupted",
  "walmartAdditionalFreeMonths": "+ 3 additional months FREE!",
  "walmartAlreadyLinked": "Hi {firstName}, a Walmart+ account is already connected with your account",
  "walmartConnectWithWalmartPlus": "Connect with Walmart+",
  "walmartDeactivateButton": "Deactivate",
  "walmartEnjoyYourOffers": "Enjoy your Walmart+ Offers!",
  "walmartErrorLinkingAccounts": "We couldn’t link the accounts",
  "walmartLanding25Off": "25% Off BK®",
  "walmartLandingBkWalmartTogether": "BK and Walmart+ together!",
  "walmartLandingDailyOn": "Daily on your digital order",
  "walmartLandingEnjoyYourExclusive": "Enjoy your exclusive offers as a Royal Perks and Walmart+ member:",
  "walmartLandingForDigital": "For digital orders",
  "walmartLandingFreeWhopper": "FREE* Whopper®",
  "walmartLandingItsBetter": "It's better together",
  "walmartLandingLinkYourRoyal": "Link your Royal Perks and Walmart+ membership and get exclusive access to even more Burger King deals:",
  "walmartLandingReadyForMoreSavings": "Ready for even more savings?",
  "walmartLandingStartingOn": "Starting on 9 / 16",
  "walmartLandingWithPurchase": "With purchase every 3 months",
  "walmartLinkAccounts": "Link Accounts",
  "walmartMembershipAlreadyConnected": "Your Walmart+ membership is already connected with another BK account: {userEmail}",
  "walmartMembershipDeal": "That’s 12 months for only $59!",
  "walmartMembershipDealMonthly": "That’s less than $8 every month for 12 months!",
  "walmartMembershipSignUp": "Walmart+ annual membership",
  "walmartMembershipSignUpMonthly": "Walmart+ monthly membership",
  "walmartOfferBadgeAlt": "Walmart offer logo",
  "walmartPartnerUserAlreadyLinked": "Your Walmart+ membership is already connected with another Royal Perks account {email}",
  "walmartPlusBenefit": "40 % OFF",
  "walmartPlusMembershipDiscount": "Royal Perks members get 40% off Walmart+ annual membership.",
  "walmartPlusMembershipDiscountMonthly": "Royal Perks members get 40% off Walmart+ monthly membership.",
  "walmartPlusWeekBottomText": "Valid at part. U.S. rest. in the BK® App or BK.com for paid Walmart+ members only. $1 min. purchase req’d for each eligible free item. Ends 5/4. Terms apply.",
  "walmartPlusWeekOffer1": "Free Croissan'wich",
  "walmartPlusWeekOffer2": "Free Whopper Jr.",
  "walmartPlusWeekOfferText": "Daily with purchase",
  "walmartSignUpSignIn": "Sign Up/Sign In to Royal Perks",
  "walmartTerms": "Valid at participating U.S. BK® restaurants, in the BK App or BK.com for BK Royal Perks & Walmart+ members only. 25% off available 1x calendar day per account. Free Whopper with any purchase available 1x quarter. Terms apply.",
  "walmartUnlinkBodyDialog": "You’ll be taken to Walmart to cancel these offers.",
  "walmartUnlinkCancelBtnDialog": "No, Keep them",
  "walmartUnlinkConfirmBtnDialog": "Yes, Deactivate",
  "walmartUnlinkTitleDialog": "Deactivate Walmart+ Offers?",
  "walmartWelcomeLinkWithWalmartPlus": "Welcome! Now lets link your Royal Perks account with Walmart+",
  "wayToGo": "Way to go! Time to redeem",
  "waysToOrder": "Ways to order",
  "weArePreparingYourOrder": "We are preparing your order and it will be placed at the front counter when ready.",
  "weArePreparingYourOrderFastLane": "We are preparing your order and it will be ready at the Fast Lane Drive Thru.",
  "weCantWaitToServeYou": "We can't wait to serve you",
  "weFoundStoreCloserToYou": "We found a store closer to you",
  "weFoundStoreCloserToYouV2": "We found a closer restaurant",
  "weHadToRemoveUnavailableItems": "We had to remove a few items that aren’t available at this location",
  "weHaveSelectedClosestStore": "We’ve selected the closest store based on your location.",
  "weWillCallNameWhenYourOrderIsReady": "We will call {name} when your order is ready.",
  "weWillEmailYouWithOrderStatus": "We will email you with the order status once we hear back from the restaurant.",
  "weWillLinkWalmart": "We will link your Walmart+ with your Royal Perks account ",
  "weWillPrepareYourOrderAtTime": "We will prepare your order at {time}",
  "wednesday": "Wednesday",
  "weight": "Weight",
  "welcome": "Welcome!",
  "welcomeBack": "Welcome Back!",
  "welcomeToBkLoyalty": "Welcome to the new BK Loyalty",
  "welcomeToYour": "Welcome to Your",
  "whatDoYouNeedHelpWith": "What do you need help with?",
  "whatIsNew": "What's New",
  "whatIsTheIssue": "What is the issue?",
  "whatWouldYouLikeToContactUsAbout": "What would you like to contact us about?",
  "wheat": "wheat",
  "whenYouHitCertainMilestones": "When you hit certain milestones in the BK® App, like ordering your favorites or trying something new, you earn a badge.",
  "whoops": "Whoops!",
  "whopperCodeErrorMessage": "Error loading code",
  "whopperCodeExpired": "Code expired",
  "whopperCodeSubtitle": "Show this code to the cashier",
  "whopperCodeTitle": "Your Whopper Code",
  "whopperGuarantee": "Whopper Guarantee",
  "whopperQrSubtitle": "Cashier can scan this code",
  "whyDoYouNeedMyPhoneNumber": "Why do you need my phone number?",
  "willPickUpOrder": "How will you be picking up your order?",
  "willSendConfirmationTo": "We'll send a confirmation email to",
  "willSendYourRequestedInfoTo": "We will send your requested information to {email}. It will take about a week for this process to be complete.",
  "winners": "Winners",
  "withYourDigitalTimCard": "with your digital Tim Card",
  "work": "Work",
  "wouldYouKikeToAdd": "Would you like to add {amount} to your Crown Card?",
  "wouldYouLikeToAddADifferentCard": "Would you like to add a different {cardAlias} Card?",
  "wouldYouLikeToAddToPrepaidCard": "Would you like to add {amount} to your {cardAlias} Card?",
  "wouldYouLikeToUseOneNowFreeItem": "Would you like to use one now to get one of your items free?",
  "wow": "WOW!",
  "xItems": "{xItems, plural, one {# item} other {# items}}",
  "xMoreOrders": "You're on your way! {pointsUntil} more orders to get a free item.",
  "xPointsUntilReward": "{points} {points, plural, one {point} other {points}} until your next reward",
  "yallReady": "Y'all Ready?",
  "yay": "Yay!",
  "year": "Year",
  "yearPlaceholder": "YYYY",
  "yes": "Yes",
  "yesAddNewCard": "Yes, Add new {cardAlias} Card",
  "yesTransfer": "Yes, Transfer {amount}",
  "youCanPayWithACardRightHere": "You can pay with a card right here!",
  "youCompletedYourMonthlyAndProfileChallenges": "You've successfully completed your Profile\nand Monthly Challenge.",
  "youCompletedYourMonthlyChallenge": "You've successfully completed your\nMonthly Challenge.",
  "youCompletedYourProfileChallenge": "You’ve successfully completed your\nProfile Challenge.",
  "youCurrentlyHaveXRewards": "You currently have {availableRedemptions} rewards",
  "youHave": "You have",
  "youHaveNumAvailableRewards": "You have {availableRedemptions} rewards.",
  "youHaveQuantityItemInCart": "You have {itemQuantity}-{itemName} in your cart now.",
  "youHaveSuccessfullySubmittedTheForm": "Your form has been successfully submitted",
  "youHaveXPoints": "YOU HAVE {pointsNumber} POINTS",
  "youQualifyFreeDelivery": "You qualify for $0 Delivery Fee!",
  "youWillBeCharged": "You will be charged {reloadAmount}.",
  "yourAddress": "Your Address",
  "yourBalanceIs": "Your current balance is {currentBalance}.",
  "yourBalanceXAddY": "Your current balance is {currentBalance}. Would you like to add {balanceToAdd} to your Tim Card?",
  "yourCardHasBeenCharged": "Your card has been charged. You will receive email confirmation within 24 hours.",
  "yourCardHasBeenSuccessfullyRegistered": "Your card has been successfully registered.",
  "yourCardIsLinked": "Your card is linked!",
  "yourCart": "Your Cart",
  "yourCartWillBeClearedIfStartCateringOrder": "Your cart will be cleared if you decide to start a catering order",
  "yourClosestStore": "Your closest store",
  "yourClosestStoreIsSelectedNow": "Your closest store is selected now!",
  "yourClosestStoreX": "Your closest store is {storeAddress}",
  "yourCourier": "Your Courier",
  "yourCrownOrders": "Your Crown Orders",
  "yourCurrentTimsRewardCardNumberIs": "Your current Tims Rewards Card Number is {userAccountNumber}",
  "yourEmail": "Your Email",
  "yourFavorites": "Favorites",
  "yourFullName": "Your Full Name",
  "yourLeastExpensiveItemFree": "Your least expensive item in this order will be free!",
  "yourLocationCannotAcceptDelivery": "Sorry, your location can’t accept deliveries at this time.",
  "yourLocationHasBeenUpdated": "Your location has been updated.",
  "yourLoyaltyHistory": "Your Rewards Orders",
  "yourName": "your name",
  "yourNewBalanceX": "Your new Tim Card balance is {newBalance}",
  "yourNewCardBalance": "Your new {cardAlias} Card balance is {amount}",
  "yourNewPaymentMethodHasBeenSuccessfullySaved": "Your new payment method has been successfully saved",
  "yourOrder": "Your Order",
  "yourOrderHasBeenPlaced": "Your order has been placed in line with other customers and will be ready as soon as possible!",
  "yourOrderIsBeingConfirmed": "Your order is being confirmed!",
  "yourOrderIsBeingPrepared": "Your order is being prepared!",
  "yourOrderIsBeingPreparedCurbside": "Your order is being prepared and will be brought to you soon.",
  "yourOrderIsConfirmed": "Your order is confirmed!",
  "yourPointsWillExpire": "Your Crowns will expire on",
  "yourRewards": "Your Rewards",
  "yourRewardsAccountNumber": "Your Tims Rewards Account Number",
  "yourRewardsCard": "Your Rewards Card",
  "yourSelectedPaymentMethodIsTimCard": "Your selected payment method is Tim card",
  "yourSelectedRestaurantIs": "Your selected restaurant is {storeAddress}",
  "yourSelectedStore": "Your selected store",
  "yourTimCardBalance": "Your Tim Card Balance",
  "yourTimsRewardsNumber": "Your Tims Rewards Number ",
  "yourUpdateIsntSavedYetBody": "Your reward level update to {selectedTierName} has not been saved yet. Select Update Reward Level for this change to take affect.",
  "yourUpdateIsntSavedYetHeading": "Your update isn’t saved yet",
  "yourWalmartPlusOffers": "Your Walmart+ Offers are Ready!",
  "yourWay": "Your Way: ",
  "yourWayToShowOff": "Your way to show off just how much you rule!",
  "yourXPointsAway": "You're {points} crowns away",
  "youreXAwayFromFreeDelivery": "You're {amount} away from $0 Delivery Fee!",
  "youveEarnedAFreeItem": "You've earned a free item!",
  "youveGotEnoughCrowns": "You've got enough Crowns",
  "zipCode": "Zip Code",
  "zipCodeError": "Please enter either a valid American zip code or a valid Canadian or U.K. postal code",
  "zipCodeInvalid": "Zip Code Invalid",
  "zipCodeRequiredError": "Zip code is a required field"
}
